import { jsx as $, Fragment as Ys, jsxs as Zt } from "react/jsx-runtime";
import * as Bn from "react";
import J, { createContext as bt, useRef as K, useLayoutEffect as Xs, useEffect as rt, useId as Fn, useContext as U, useInsertionEffect as qs, useMemo as dt, useCallback as de, Children as Zs, isValidElement as ea, useState as at, Fragment as Js, createElement as na, forwardRef as kt, Component as ia, useImperativeHandle as sa, cloneElement as oa } from "react";
import { o as ra } from "./index-CcECYkhV.mjs";
import { createPortal as aa } from "react-dom";
import { u as la, P as ca } from "./pc-dialog-sheet-C01qdZ44.mjs";
import { c as xe } from "./tw-cn-mXgPecoF.mjs";
import "./client-COlxxEJZ.mjs";
import { t as ua } from "./throttle-CbOTDqvg.mjs";
const On = bt({});
function me(t) {
  const e = K(null);
  return e.current === null && (e.current = t()), e.current;
}
const Nn = typeof window < "u", jn = Nn ? Xs : rt, Ne = /* @__PURE__ */ bt(null);
function $n(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function je(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const mt = (t, e, n) => n > e ? e : n < t ? t : n;
function fn(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let Ht = () => {
}, it = () => {
};
process.env.NODE_ENV !== "production" && (Ht = (t, e, n) => {
  !t && typeof console < "u" && console.warn(fn(e, n));
}, it = (t, e, n) => {
  if (!t)
    throw new Error(fn(e, n));
});
const pt = {}, Qs = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
function to(t) {
  return typeof t == "object" && t !== null;
}
const eo = (t) => /^0[^.\s]+$/u.test(t);
// @__NO_SIDE_EFFECTS__
function Un(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const et = /* @__NO_SIDE_EFFECTS__ */ (t) => t, ha = (t, e) => (n) => e(t(n)), pe = (...t) => t.reduce(ha), Wt = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const i = e - t;
  return i === 0 ? 1 : (n - t) / i;
};
class Wn {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return $n(this.subscriptions, e), () => je(this.subscriptions, e);
  }
  notify(e, n, i) {
    const s = this.subscriptions.length;
    if (s)
      if (s === 1)
        this.subscriptions[0](e, n, i);
      else
        for (let r = 0; r < s; r++) {
          const o = this.subscriptions[r];
          o && o(e, n, i);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const nt = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, lt = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function no(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const bi = /* @__PURE__ */ new Set();
function $e(t, e, n) {
  t || bi.has(e) || (console.warn(fn(e, n)), bi.add(e));
}
const fa = (t, e, n) => {
  const i = e - t;
  return ((n - t) % i + i) % i + t;
}, io = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, da = 1e-7, ma = 12;
function pa(t, e, n, i, s) {
  let r, o, a = 0;
  do
    o = e + (n - e) / 2, r = io(o, i, s) - t, r > 0 ? n = o : e = o;
  while (Math.abs(r) > da && ++a < ma);
  return o;
}
function ge(t, e, n, i) {
  if (t === e && n === i)
    return et;
  const s = (r) => pa(r, 0, 1, t, n);
  return (r) => r === 0 || r === 1 ? r : io(s(r), e, i);
}
const so = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, oo = (t) => (e) => 1 - t(1 - e), ro = /* @__PURE__ */ ge(0.33, 1.53, 0.69, 0.99), _n = /* @__PURE__ */ oo(ro), ao = /* @__PURE__ */ so(_n), lo = (t) => (t *= 2) < 1 ? 0.5 * _n(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Hn = (t) => 1 - Math.sin(Math.acos(t)), co = oo(Hn), uo = so(Hn), ga = /* @__PURE__ */ ge(0.42, 0, 1, 1), ya = /* @__PURE__ */ ge(0, 0, 0.58, 1), ho = /* @__PURE__ */ ge(0.42, 0, 0.58, 1), fo = (t) => Array.isArray(t) && typeof t[0] != "number";
function mo(t, e) {
  return fo(t) ? t[fa(0, t.length, e)] : t;
}
const po = (t) => Array.isArray(t) && typeof t[0] == "number", Si = {
  linear: et,
  easeIn: ga,
  easeInOut: ho,
  easeOut: ya,
  circIn: Hn,
  circInOut: uo,
  circOut: co,
  backIn: _n,
  backInOut: ao,
  backOut: ro,
  anticipate: lo
}, va = (t) => typeof t == "string", wi = (t) => {
  if (po(t)) {
    it(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, n, i, s] = t;
    return ge(e, n, i, s);
  } else if (va(t))
    return it(Si[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), Si[t];
  return t;
}, be = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function Ta(t, e) {
  let n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), s = !1, r = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(c) {
    o.has(c) && (u.schedule(c), t()), c(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, h = !1, f = !1) => {
      const m = f && s ? n : i;
      return h && o.add(c), m.has(c) || m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      i.delete(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, s) {
        r = !0;
        return;
      }
      s = !0, [n, i] = [i, n], n.forEach(l), n.clear(), s = !1, r && (r = !1, u.process(c));
    }
  };
  return u;
}
const xa = 40;
function go(t, e) {
  let n = !1, i = !0;
  const s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, r = () => n = !0, o = be.reduce((T, w) => (T[w] = Ta(r), T), {}), { setup: a, read: l, resolveKeyframes: u, preUpdate: c, update: h, preRender: f, render: d, postRender: m } = o, g = () => {
    const T = pt.useManualTiming ? s.timestamp : performance.now();
    n = !1, pt.useManualTiming || (s.delta = i ? 1e3 / 60 : Math.max(Math.min(T - s.timestamp, xa), 1)), s.timestamp = T, s.isProcessing = !0, a.process(s), l.process(s), u.process(s), c.process(s), h.process(s), f.process(s), d.process(s), m.process(s), s.isProcessing = !1, n && e && (i = !1, t(g));
  }, y = () => {
    n = !0, i = !0, s.isProcessing || t(g);
  };
  return { schedule: be.reduce((T, w) => {
    const x = o[w];
    return T[w] = (S, A = !1, b = !1) => (n || y(), x.schedule(S, A, b)), T;
  }, {}), cancel: (T) => {
    for (let w = 0; w < be.length; w++)
      o[be[w]].cancel(T);
  }, state: s, steps: o };
}
const { schedule: L, cancel: gt, state: H, steps: Ye } = /* @__PURE__ */ go(typeof requestAnimationFrame < "u" ? requestAnimationFrame : et, !0);
let Ce;
function ba() {
  Ce = void 0;
}
const Z = {
  now: () => (Ce === void 0 && Z.set(H.isProcessing || pt.useManualTiming ? H.timestamp : performance.now()), Ce),
  set: (t) => {
    Ce = t, queueMicrotask(ba);
  }
}, yo = (t) => (e) => typeof e == "string" && e.startsWith(t), Kn = /* @__PURE__ */ yo("--"), Sa = /* @__PURE__ */ yo("var(--"), Gn = (t) => Sa(t) ? wa.test(t.split("/*")[0].trim()) : !1, wa = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Kt = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, oe = {
  ...Kt,
  transform: (t) => mt(0, 1, t)
}, Se = {
  ...Kt,
  default: 1
}, Qt = (t) => Math.round(t * 1e5) / 1e5, zn = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Pa(t) {
  return t == null;
}
const Aa = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Yn = (t, e) => (n) => !!(typeof n == "string" && Aa.test(n) && n.startsWith(t) || e && !Pa(n) && Object.prototype.hasOwnProperty.call(n, e)), vo = (t, e, n) => (i) => {
  if (typeof i != "string")
    return i;
  const [s, r, o, a] = i.match(zn);
  return {
    [t]: parseFloat(s),
    [e]: parseFloat(r),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, Va = (t) => mt(0, 255, t), Xe = {
  ...Kt,
  transform: (t) => Math.round(Va(t))
}, Et = {
  test: /* @__PURE__ */ Yn("rgb", "red"),
  parse: /* @__PURE__ */ vo("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: i = 1 }) => "rgba(" + Xe.transform(t) + ", " + Xe.transform(e) + ", " + Xe.transform(n) + ", " + Qt(oe.transform(i)) + ")"
};
function Ca(t) {
  let e = "", n = "", i = "", s = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), i = t.substring(5, 7), s = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), i = t.substring(3, 4), s = t.substring(4, 5), e += e, n += n, i += i, s += s), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(i, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const dn = {
  test: /* @__PURE__ */ Yn("#"),
  parse: Ca,
  transform: Et.transform
}, ye = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), vt = /* @__PURE__ */ ye("deg"), ct = /* @__PURE__ */ ye("%"), P = /* @__PURE__ */ ye("px"), Ea = /* @__PURE__ */ ye("vh"), Da = /* @__PURE__ */ ye("vw"), Pi = {
  ...ct,
  parse: (t) => ct.parse(t) / 100,
  transform: (t) => ct.transform(t * 100)
}, Bt = {
  test: /* @__PURE__ */ Yn("hsl", "hue"),
  parse: /* @__PURE__ */ vo("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: i = 1 }) => "hsla(" + Math.round(t) + ", " + ct.transform(Qt(e)) + ", " + ct.transform(Qt(n)) + ", " + Qt(oe.transform(i)) + ")"
}, j = {
  test: (t) => Et.test(t) || dn.test(t) || Bt.test(t),
  parse: (t) => Et.test(t) ? Et.parse(t) : Bt.test(t) ? Bt.parse(t) : dn.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? Et.transform(t) : Bt.transform(t),
  getAnimatableNone: (t) => {
    const e = j.parse(t);
    return e.alpha = 0, j.transform(e);
  }
}, Ma = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Ra(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(zn)) == null ? void 0 : e.length) || 0) + (((n = t.match(Ma)) == null ? void 0 : n.length) || 0) > 0;
}
const To = "number", xo = "color", La = "var", ka = "var(", Ai = "${}", Ia = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function re(t) {
  const e = t.toString(), n = [], i = {
    color: [],
    number: [],
    var: []
  }, s = [];
  let r = 0;
  const a = e.replace(Ia, (l) => (j.test(l) ? (i.color.push(r), s.push(xo), n.push(j.parse(l))) : l.startsWith(ka) ? (i.var.push(r), s.push(La), n.push(l)) : (i.number.push(r), s.push(To), n.push(parseFloat(l))), ++r, Ai)).split(Ai);
  return { values: n, split: a, indexes: i, types: s };
}
function bo(t) {
  return re(t).values;
}
function So(t) {
  const { split: e, types: n } = re(t), i = e.length;
  return (s) => {
    let r = "";
    for (let o = 0; o < i; o++)
      if (r += e[o], s[o] !== void 0) {
        const a = n[o];
        a === To ? r += Qt(s[o]) : a === xo ? r += j.transform(s[o]) : r += s[o];
      }
    return r;
  };
}
const Ba = (t) => typeof t == "number" ? 0 : j.test(t) ? j.getAnimatableNone(t) : t;
function Fa(t) {
  const e = bo(t);
  return So(t)(e.map(Ba));
}
const xt = {
  test: Ra,
  parse: bo,
  createTransformer: So,
  getAnimatableNone: Fa
};
function qe(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function Oa({ hue: t, saturation: e, lightness: n, alpha: i }) {
  t /= 360, e /= 100, n /= 100;
  let s = 0, r = 0, o = 0;
  if (!e)
    s = r = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    s = qe(l, a, t + 1 / 3), r = qe(l, a, t), o = qe(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(r * 255),
    blue: Math.round(o * 255),
    alpha: i
  };
}
function Le(t, e) {
  return (n) => n > 0 ? e : t;
}
const k = (t, e, n) => t + (e - t) * n, Ze = (t, e, n) => {
  const i = t * t, s = n * (e * e - i) + i;
  return s < 0 ? 0 : Math.sqrt(s);
}, Na = [dn, Et, Bt], ja = (t) => Na.find((e) => e.test(t));
function Vi(t) {
  const e = ja(t);
  if (Ht(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let n = e.parse(t);
  return e === Bt && (n = Oa(n)), n;
}
const Ci = (t, e) => {
  const n = Vi(t), i = Vi(e);
  if (!n || !i)
    return Le(t, e);
  const s = { ...n };
  return (r) => (s.red = Ze(n.red, i.red, r), s.green = Ze(n.green, i.green, r), s.blue = Ze(n.blue, i.blue, r), s.alpha = k(n.alpha, i.alpha, r), Et.transform(s));
}, mn = /* @__PURE__ */ new Set(["none", "hidden"]);
function $a(t, e) {
  return mn.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function Ua(t, e) {
  return (n) => k(t, e, n);
}
function Xn(t) {
  return typeof t == "number" ? Ua : typeof t == "string" ? Gn(t) ? Le : j.test(t) ? Ci : Ha : Array.isArray(t) ? wo : typeof t == "object" ? j.test(t) ? Ci : Wa : Le;
}
function wo(t, e) {
  const n = [...t], i = n.length, s = t.map((r, o) => Xn(r)(r, e[o]));
  return (r) => {
    for (let o = 0; o < i; o++)
      n[o] = s[o](r);
    return n;
  };
}
function Wa(t, e) {
  const n = { ...t, ...e }, i = {};
  for (const s in n)
    t[s] !== void 0 && e[s] !== void 0 && (i[s] = Xn(t[s])(t[s], e[s]));
  return (s) => {
    for (const r in i)
      n[r] = i[r](s);
    return n;
  };
}
function _a(t, e) {
  const n = [], i = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < e.values.length; s++) {
    const r = e.types[s], o = t.indexes[r][i[r]], a = t.values[o] ?? 0;
    n[s] = a, i[r]++;
  }
  return n;
}
const Ha = (t, e) => {
  const n = xt.createTransformer(e), i = re(t), s = re(e);
  return i.indexes.var.length === s.indexes.var.length && i.indexes.color.length === s.indexes.color.length && i.indexes.number.length >= s.indexes.number.length ? mn.has(t) && !s.values.length || mn.has(e) && !i.values.length ? $a(t, e) : pe(wo(_a(i, s), s.values), n) : (Ht(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Le(t, e));
};
function Po(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? k(t, e, n) : Xn(t)(t, e);
}
const Ka = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: (n = !0) => L.update(e, n),
    stop: () => gt(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => H.isProcessing ? H.timestamp : Z.now()
  };
}, Ao = (t, e, n = 10) => {
  let i = "";
  const s = Math.max(Math.round(e / n), 2);
  for (let r = 0; r < s; r++)
    i += Math.round(t(r / (s - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${i.substring(0, i.length - 2)})`;
}, ke = 2e4;
function qn(t) {
  let e = 0;
  const n = 50;
  let i = t.next(e);
  for (; !i.done && e < ke; )
    e += n, i = t.next(e);
  return e >= ke ? 1 / 0 : e;
}
function Vo(t, e = 100, n) {
  const i = n({ ...t, keyframes: [0, e] }), s = Math.min(qn(i), ke);
  return {
    type: "keyframes",
    ease: (r) => i.next(s * r).value / e,
    duration: /* @__PURE__ */ lt(s)
  };
}
const Ga = 5;
function Co(t, e, n) {
  const i = Math.max(e - Ga, 0);
  return no(n - t(i), e - i);
}
const I = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Je = 1e-3;
function za({ duration: t = I.duration, bounce: e = I.bounce, velocity: n = I.velocity, mass: i = I.mass }) {
  let s, r;
  Ht(t <= /* @__PURE__ */ nt(I.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - e;
  o = mt(I.minDamping, I.maxDamping, o), t = mt(I.minDuration, I.maxDuration, /* @__PURE__ */ lt(t)), o < 1 ? (s = (u) => {
    const c = u * o, h = c * t, f = c - n, d = pn(u, o), m = Math.exp(-h);
    return Je - f / d * m;
  }, r = (u) => {
    const h = u * o * t, f = h * n + n, d = Math.pow(o, 2) * Math.pow(u, 2) * t, m = Math.exp(-h), g = pn(Math.pow(u, 2), o);
    return (-s(u) + Je > 0 ? -1 : 1) * ((f - d) * m) / g;
  }) : (s = (u) => {
    const c = Math.exp(-u * t), h = (u - n) * t + 1;
    return -Je + c * h;
  }, r = (u) => {
    const c = Math.exp(-u * t), h = (n - u) * (t * t);
    return c * h;
  });
  const a = 5 / t, l = Xa(s, r, a);
  if (t = /* @__PURE__ */ nt(t), isNaN(l))
    return {
      stiffness: I.stiffness,
      damping: I.damping,
      duration: t
    };
  {
    const u = Math.pow(l, 2) * i;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(i * u),
      duration: t
    };
  }
}
const Ya = 12;
function Xa(t, e, n) {
  let i = n;
  for (let s = 1; s < Ya; s++)
    i = i - t(i) / e(i);
  return i;
}
function pn(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const qa = ["duration", "bounce"], Za = ["stiffness", "damping", "mass"];
function Ei(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Ja(t) {
  let e = {
    velocity: I.velocity,
    stiffness: I.stiffness,
    damping: I.damping,
    mass: I.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Ei(t, Za) && Ei(t, qa))
    if (t.visualDuration) {
      const n = t.visualDuration, i = 2 * Math.PI / (n * 1.2), s = i * i, r = 2 * mt(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(s);
      e = {
        ...e,
        mass: I.mass,
        stiffness: s,
        damping: r
      };
    } else {
      const n = za(t);
      e = {
        ...e,
        ...n,
        mass: I.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function ae(t = I.visualDuration, e = I.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: i, restDelta: s } = n;
  const r = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: r }, { stiffness: l, damping: u, mass: c, duration: h, velocity: f, isResolvedFromDuration: d } = Ja({
    ...n,
    velocity: -/* @__PURE__ */ lt(n.velocity || 0)
  }), m = f || 0, g = u / (2 * Math.sqrt(l * c)), y = o - r, p = /* @__PURE__ */ lt(Math.sqrt(l / c)), v = Math.abs(y) < 5;
  i || (i = v ? I.restSpeed.granular : I.restSpeed.default), s || (s = v ? I.restDelta.granular : I.restDelta.default);
  let T;
  if (g < 1) {
    const x = pn(p, g);
    T = (S) => {
      const A = Math.exp(-g * p * S);
      return o - A * ((m + g * p * y) / x * Math.sin(x * S) + y * Math.cos(x * S));
    };
  } else if (g === 1)
    T = (x) => o - Math.exp(-p * x) * (y + (m + p * y) * x);
  else {
    const x = p * Math.sqrt(g * g - 1);
    T = (S) => {
      const A = Math.exp(-g * p * S), b = Math.min(x * S, 300);
      return o - A * ((m + g * p * y) * Math.sinh(b) + x * y * Math.cosh(b)) / x;
    };
  }
  const w = {
    calculatedDuration: d && h || null,
    next: (x) => {
      const S = T(x);
      if (d)
        a.done = x >= h;
      else {
        let A = x === 0 ? m : 0;
        g < 1 && (A = x === 0 ? /* @__PURE__ */ nt(m) : Co(T, x, S));
        const b = Math.abs(A) <= i, V = Math.abs(o - S) <= s;
        a.done = b && V;
      }
      return a.value = a.done ? o : S, a;
    },
    toString: () => {
      const x = Math.min(qn(w), ke), S = Ao((A) => w.next(x * A).value, x, 30);
      return x + "ms " + S;
    },
    toTransition: () => {
    }
  };
  return w;
}
ae.applyToOptions = (t) => {
  const e = Vo(t, 100, ae);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ nt(e.duration), t.type = "keyframes", t;
};
function gn({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: i = 325, bounceDamping: s = 10, bounceStiffness: r = 500, modifyTarget: o, min: a, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const h = t[0], f = {
    done: !1,
    value: h
  }, d = (b) => a !== void 0 && b < a || l !== void 0 && b > l, m = (b) => a === void 0 ? l : l === void 0 || Math.abs(a - b) < Math.abs(l - b) ? a : l;
  let g = n * e;
  const y = h + g, p = o === void 0 ? y : o(y);
  p !== y && (g = p - h);
  const v = (b) => -g * Math.exp(-b / i), T = (b) => p + v(b), w = (b) => {
    const V = v(b), D = T(b);
    f.done = Math.abs(V) <= u, f.value = f.done ? p : D;
  };
  let x, S;
  const A = (b) => {
    d(f.value) && (x = b, S = ae({
      keyframes: [f.value, m(f.value)],
      velocity: Co(T, b, f.value),
      // TODO: This should be passing * 1000
      damping: s,
      stiffness: r,
      restDelta: u,
      restSpeed: c
    }));
  };
  return A(0), {
    calculatedDuration: null,
    next: (b) => {
      let V = !1;
      return !S && x === void 0 && (V = !0, w(b), A(b)), x !== void 0 && b >= x ? S.next(b - x) : (!V && w(b), f);
    }
  };
}
function Qa(t, e, n) {
  const i = [], s = n || pt.mix || Po, r = t.length - 1;
  for (let o = 0; o < r; o++) {
    let a = s(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || et : e;
      a = pe(l, a);
    }
    i.push(a);
  }
  return i;
}
function Eo(t, e, { clamp: n = !0, ease: i, mixer: s } = {}) {
  const r = t.length;
  if (it(r === e.length, "Both input and output ranges must be the same length", "range-length"), r === 1)
    return () => e[0];
  if (r === 2 && e[0] === e[1])
    return () => e[1];
  const o = t[0] === t[1];
  t[0] > t[r - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const a = Qa(e, i, s), l = a.length, u = (c) => {
    if (o && c < t[0])
      return e[0];
    let h = 0;
    if (l > 1)
      for (; h < t.length - 2 && !(c < t[h + 1]); h++)
        ;
    const f = /* @__PURE__ */ Wt(t[h], t[h + 1], c);
    return a[h](f);
  };
  return n ? (c) => u(mt(t[0], t[r - 1], c)) : u;
}
function Do(t, e) {
  const n = t[t.length - 1];
  for (let i = 1; i <= e; i++) {
    const s = /* @__PURE__ */ Wt(0, e, i);
    t.push(k(n, 1, s));
  }
}
function Mo(t) {
  const e = [0];
  return Do(e, t.length - 1), e;
}
function tl(t, e) {
  return t.map((n) => n * e);
}
function el(t, e) {
  return t.map(() => e || ho).splice(0, t.length - 1);
}
function Ft({ duration: t = 300, keyframes: e, times: n, ease: i = "easeInOut" }) {
  const s = fo(i) ? i.map(wi) : wi(i), r = {
    done: !1,
    value: e[0]
  }, o = tl(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Mo(e),
    t
  ), a = Eo(o, e, {
    ease: Array.isArray(s) ? s : el(e, s)
  });
  return {
    calculatedDuration: t,
    next: (l) => (r.value = a(l), r.done = l >= t, r)
  };
}
const nl = (t) => t !== null;
function Zn(t, { repeat: e, repeatType: n = "loop" }, i, s = 1) {
  const r = t.filter(nl), a = s < 0 || e && n !== "loop" && e % 2 === 1 ? 0 : r.length - 1;
  return !a || i === void 0 ? r[a] : i;
}
const il = {
  decay: gn,
  inertia: gn,
  tween: Ft,
  keyframes: Ft,
  spring: ae
};
function Ro(t) {
  typeof t.type == "string" && (t.type = il[t.type]);
}
class Jn {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const sl = (t) => t / 100;
class Qn extends Jn {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var i, s;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== Z.now() && this.tick(Z.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (s = (i = this.options).onStop) == null || s.call(i));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    Ro(e);
    const { type: n = Ft, repeat: i = 0, repeatDelay: s = 0, repeatType: r, velocity: o = 0 } = e;
    let { keyframes: a } = e;
    const l = n || Ft;
    process.env.NODE_ENV !== "production" && l !== Ft && it(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== Ft && typeof a[0] != "number" && (this.mixKeyframes = pe(sl, Po(a[0], a[1])), a = [0, 100]);
    const u = l({ ...e, keyframes: a });
    r === "mirror" && (this.mirroredGenerator = l({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = qn(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + s, this.totalDuration = this.resolvedDuration * (i + 1) - s, this.generator = u;
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(e, n = !1) {
    const { generator: i, totalDuration: s, mixKeyframes: r, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return i.next(0);
    const { delay: u = 0, keyframes: c, repeat: h, repeatType: f, repeatDelay: d, type: m, onUpdate: g, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - s / this.speed, this.startTime)), n ? this.currentTime = e : this.updateTime(e);
    const p = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), v = this.playbackSpeed >= 0 ? p < 0 : p > s;
    this.currentTime = Math.max(p, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = s);
    let T = this.currentTime, w = i;
    if (h) {
      const b = Math.min(this.currentTime, s) / a;
      let V = Math.floor(b), D = b % 1;
      !D && b >= 1 && (D = 1), D === 1 && V--, V = Math.min(V, h + 1), !!(V % 2) && (f === "reverse" ? (D = 1 - D, d && (D -= d / a)) : f === "mirror" && (w = o)), T = mt(0, 1, D) * a;
    }
    const x = v ? { done: !1, value: c[0] } : w.next(T);
    r && (x.value = r(x.value));
    let { done: S } = x;
    !v && l !== null && (S = this.playbackSpeed >= 0 ? this.currentTime >= s : this.currentTime <= 0);
    const A = this.holdTime === null && (this.state === "finished" || this.state === "running" && S);
    return A && m !== gn && (x.value = Zn(c, this.options, y, this.speed)), g && g(x.value), A && this.finish(), x;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return /* @__PURE__ */ lt(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ lt(this.currentTime);
  }
  set time(e) {
    var n;
    e = /* @__PURE__ */ nt(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(Z.now());
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ lt(this.currentTime));
  }
  play() {
    var s, r;
    if (this.isStopped)
      return;
    const { driver: e = Ka, startTime: n } = this.options;
    this.driver || (this.driver = e((o) => this.tick(o))), (r = (s = this.options).onPlay) == null || r.call(s);
    const i = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = i) : this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime || (this.startTime = n ?? i), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Z.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (e = this.options).onComplete) == null || n.call(e);
  }
  cancel() {
    var e, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (e = this.options).onCancel) == null || n.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), e.observe(this);
  }
}
function ol(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const Dt = (t) => t * 180 / Math.PI, yn = (t) => {
  const e = Dt(Math.atan2(t[1], t[0]));
  return vn(e);
}, rl = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
  rotate: yn,
  rotateZ: yn,
  skewX: (t) => Dt(Math.atan(t[1])),
  skewY: (t) => Dt(Math.atan(t[2])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2
}, vn = (t) => (t = t % 360, t < 0 && (t += 360), t), Di = yn, Mi = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]), Ri = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]), al = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Mi,
  scaleY: Ri,
  scale: (t) => (Mi(t) + Ri(t)) / 2,
  rotateX: (t) => vn(Dt(Math.atan2(t[6], t[5]))),
  rotateY: (t) => vn(Dt(Math.atan2(-t[2], t[0]))),
  rotateZ: Di,
  rotate: Di,
  skewX: (t) => Dt(Math.atan(t[4])),
  skewY: (t) => Dt(Math.atan(t[1])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2
};
function Tn(t) {
  return t.includes("scale") ? 1 : 0;
}
function xn(t, e) {
  if (!t || t === "none")
    return Tn(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let i, s;
  if (n)
    i = al, s = n;
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    i = rl, s = a;
  }
  if (!s)
    return Tn(e);
  const r = i[e], o = s[1].split(",").map(cl);
  return typeof r == "function" ? r(o) : o[r];
}
const ll = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return xn(n, e);
};
function cl(t) {
  return parseFloat(t.trim());
}
const Gt = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], zt = new Set(Gt), Li = (t) => t === Kt || t === P, ul = /* @__PURE__ */ new Set(["x", "y", "z"]), hl = Gt.filter((t) => !ul.has(t));
function fl(t) {
  const e = [];
  return hl.forEach((n) => {
    const i = t.getValue(n);
    i !== void 0 && (e.push([n, i.get()]), i.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const Mt = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, { transform: e }) => xn(e, "x"),
  y: (t, { transform: e }) => xn(e, "y")
};
Mt.translateX = Mt.x;
Mt.translateY = Mt.y;
const Rt = /* @__PURE__ */ new Set();
let bn = !1, Sn = !1, wn = !1;
function Lo() {
  if (Sn) {
    const t = Array.from(Rt).filter((i) => i.needsMeasurement), e = new Set(t.map((i) => i.element)), n = /* @__PURE__ */ new Map();
    e.forEach((i) => {
      const s = fl(i);
      s.length && (n.set(i, s), i.render());
    }), t.forEach((i) => i.measureInitialState()), e.forEach((i) => {
      i.render();
      const s = n.get(i);
      s && s.forEach(([r, o]) => {
        var a;
        (a = i.getValue(r)) == null || a.set(o);
      });
    }), t.forEach((i) => i.measureEndState()), t.forEach((i) => {
      i.suspendedScrollY !== void 0 && window.scrollTo(0, i.suspendedScrollY);
    });
  }
  Sn = !1, bn = !1, Rt.forEach((t) => t.complete(wn)), Rt.clear();
}
function ko() {
  Rt.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Sn = !0);
  });
}
function dl() {
  wn = !0, ko(), Lo(), wn = !1;
}
class ti {
  constructor(e, n, i, s, r, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = i, this.motionValue = s, this.element = r, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Rt.add(this), bn || (bn = !0, L.read(ko), L.resolveKeyframes(Lo))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: i, motionValue: s } = this;
    if (e[0] === null) {
      const r = s == null ? void 0 : s.get(), o = e[e.length - 1];
      if (r !== void 0)
        e[0] = r;
      else if (i && n) {
        const a = i.readValue(n, o);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = o), s && r === void 0 && s.set(e[0]);
    }
    ol(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Rt.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Rt.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const ml = (t) => t.startsWith("--");
function pl(t, e, n) {
  ml(e) ? t.style.setProperty(e, n) : t.style[e] = n;
}
const gl = /* @__PURE__ */ Un(() => window.ScrollTimeline !== void 0), yl = {};
function vl(t, e) {
  const n = /* @__PURE__ */ Un(t);
  return () => yl[e] ?? n();
}
const Io = /* @__PURE__ */ vl(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Jt = ([t, e, n, i]) => `cubic-bezier(${t}, ${e}, ${n}, ${i})`, ki = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Jt([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Jt([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Jt([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Jt([0.33, 1.53, 0.69, 0.99])
};
function Bo(t, e) {
  if (t)
    return typeof t == "function" ? Io() ? Ao(t, e) : "ease-out" : po(t) ? Jt(t) : Array.isArray(t) ? t.map((n) => Bo(n, e) || ki.easeOut) : ki[t];
}
function Tl(t, e, n, { delay: i = 0, duration: s = 300, repeat: r = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [e]: n
  };
  l && (c.offset = l);
  const h = Bo(a, s);
  Array.isArray(h) && (c.easing = h);
  const f = {
    delay: i,
    duration: s,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: r + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (f.pseudoElement = u), t.animate(c, f);
}
function ei(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function xl({ type: t, ...e }) {
  return ei(t) && Io() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class bl extends Jn {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !e)
      return;
    const { element: n, name: i, keyframes: s, pseudoElement: r, allowFlatten: o = !1, finalKeyframe: a, onComplete: l } = e;
    this.isPseudoElement = !!r, this.allowFlatten = o, this.options = e, it(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = xl(e);
    this.animation = Tl(n, i, s, u, r), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !r) {
        const c = Zn(s, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : pl(n, i, c), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, n;
    (n = (e = this.animation).finish) == null || n.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, n;
    this.isPseudoElement || (n = (e = this.animation).commitStyles) == null || n.call(e);
  }
  get duration() {
    var n, i;
    const e = ((i = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : i.call(n).duration) || 0;
    return /* @__PURE__ */ lt(Number(e));
  }
  get time() {
    return /* @__PURE__ */ lt(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ nt(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, observe: n }) {
    var i;
    return this.allowFlatten && ((i = this.animation.effect) == null || i.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && gl() ? (this.animation.timeline = e, et) : n(this);
  }
}
const Fo = {
  anticipate: lo,
  backInOut: ao,
  circInOut: uo
};
function Sl(t) {
  return t in Fo;
}
function wl(t) {
  typeof t.ease == "string" && Sl(t.ease) && (t.ease = Fo[t.ease]);
}
const Ii = 10;
class Pl extends bl {
  constructor(e) {
    wl(e), Ro(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: n, onUpdate: i, onComplete: s, element: r, ...o } = this.options;
    if (!n)
      return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const a = new Qn({
      ...o,
      autoplay: !1
    }), l = /* @__PURE__ */ nt(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(l - Ii).value, a.sample(l).value, Ii), a.stop();
  }
}
const Bi = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(xt.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function Al(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function Vl(t, e, n, i) {
  const s = t[0];
  if (s === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const r = t[t.length - 1], o = Bi(s, e), a = Bi(r, e);
  return Ht(o === a, `You are trying to animate ${e} from "${s}" to "${r}". "${o ? r : s}" is not an animatable value.`, "value-not-animatable"), !o || !a ? !1 : Al(t) || (n === "spring" || ei(n)) && i;
}
function Pn(t) {
  t.duration = 0, t.type;
}
const Cl = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), El = /* @__PURE__ */ Un(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Dl(t) {
  var c;
  const { motionValue: e, name: n, repeatDelay: i, repeatType: s, damping: r, type: o } = t;
  if (!(((c = e == null ? void 0 : e.owner) == null ? void 0 : c.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: l, transformTemplate: u } = e.owner.getProps();
  return El() && n && Cl.has(n) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !i && s !== "mirror" && r !== 0 && o !== "inertia";
}
const Ml = 40;
class Rl extends Jn {
  constructor({ autoplay: e = !0, delay: n = 0, type: i = "keyframes", repeat: s = 0, repeatDelay: r = 0, repeatType: o = "loop", keyframes: a, name: l, motionValue: u, element: c, ...h }) {
    var m;
    super(), this.stop = () => {
      var g, y;
      this._animation && (this._animation.stop(), (g = this.stopTimeline) == null || g.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = Z.now();
    const f = {
      autoplay: e,
      delay: n,
      type: i,
      repeat: s,
      repeatDelay: r,
      repeatType: o,
      name: l,
      motionValue: u,
      element: c,
      ...h
    }, d = (c == null ? void 0 : c.KeyframeResolver) || ti;
    this.keyframeResolver = new d(a, (g, y, p) => this.onKeyframesResolved(g, y, f, !p), l, u, c), (m = this.keyframeResolver) == null || m.scheduleResolve();
  }
  onKeyframesResolved(e, n, i, s) {
    this.keyframeResolver = void 0;
    const { name: r, type: o, velocity: a, delay: l, isHandoff: u, onUpdate: c } = i;
    this.resolvedAt = Z.now(), Vl(e, r, o, a) || ((pt.instantAnimations || !l) && (c == null || c(Zn(e, i, n))), e[0] = e[e.length - 1], Pn(i), i.repeat = 0);
    const f = {
      startTime: s ? this.resolvedAt ? this.resolvedAt - this.createdAt > Ml ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...i,
      keyframes: e
    }, d = !u && Dl(f) ? new Pl({
      ...f,
      element: f.motionValue.owner.current
    }) : new Qn(f);
    d.finished.then(() => this.notifyFinished()).catch(et), this.pendingTimeline && (this.stopTimeline = d.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = d;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), dl()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
class Ll {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => e.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let i = 0; i < this.animations.length; i++)
      this.animations[i][e] = n;
  }
  attachTimeline(e) {
    const n = this.animations.map((i) => i.attachTimeline(e));
    return () => {
      n.forEach((i, s) => {
        i && i(), this.animations[s].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class kl extends Ll {
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
}
const Il = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Bl(t) {
  const e = Il.exec(t);
  if (!e)
    return [,];
  const [, n, i, s] = e;
  return [`--${n ?? i}`, s];
}
const Fl = 4;
function Oo(t, e, n = 1) {
  it(n <= Fl, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [i, s] = Bl(t);
  if (!i)
    return;
  const r = window.getComputedStyle(e).getPropertyValue(i);
  if (r) {
    const o = r.trim();
    return Qs(o) ? parseFloat(o) : o;
  }
  return Gn(s) ? Oo(s, e, n + 1) : s;
}
function ni(t, e) {
  return (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
}
const No = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Gt
]), Ol = {
  test: (t) => t === "auto",
  parse: (t) => t
}, jo = (t) => (e) => e.test(t), $o = [Kt, P, ct, vt, Da, Ea, Ol], Fi = (t) => $o.find(jo(t));
function Nl(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || eo(t) : !0;
}
const jl = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function $l(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [i] = n.match(zn) || [];
  if (!i)
    return t;
  const s = n.replace(i, "");
  let r = jl.has(e) ? 1 : 0;
  return i !== n && (r *= 100), e + "(" + r + s + ")";
}
const Ul = /\b([a-z-]*)\(.*?\)/gu, An = {
  ...xt,
  getAnimatableNone: (t) => {
    const e = t.match(Ul);
    return e ? e.map($l).join(" ") : t;
  }
}, Oi = {
  ...Kt,
  transform: Math.round
}, Wl = {
  rotate: vt,
  rotateX: vt,
  rotateY: vt,
  rotateZ: vt,
  scale: Se,
  scaleX: Se,
  scaleY: Se,
  scaleZ: Se,
  skew: vt,
  skewX: vt,
  skewY: vt,
  distance: P,
  translateX: P,
  translateY: P,
  translateZ: P,
  x: P,
  y: P,
  z: P,
  perspective: P,
  transformPerspective: P,
  opacity: oe,
  originX: Pi,
  originY: Pi,
  originZ: P
}, ii = {
  // Border props
  borderWidth: P,
  borderTopWidth: P,
  borderRightWidth: P,
  borderBottomWidth: P,
  borderLeftWidth: P,
  borderRadius: P,
  radius: P,
  borderTopLeftRadius: P,
  borderTopRightRadius: P,
  borderBottomRightRadius: P,
  borderBottomLeftRadius: P,
  // Positioning props
  width: P,
  maxWidth: P,
  height: P,
  maxHeight: P,
  top: P,
  right: P,
  bottom: P,
  left: P,
  // Spacing props
  padding: P,
  paddingTop: P,
  paddingRight: P,
  paddingBottom: P,
  paddingLeft: P,
  margin: P,
  marginTop: P,
  marginRight: P,
  marginBottom: P,
  marginLeft: P,
  // Misc
  backgroundPositionX: P,
  backgroundPositionY: P,
  ...Wl,
  zIndex: Oi,
  // SVG
  fillOpacity: oe,
  strokeOpacity: oe,
  numOctaves: Oi
}, _l = {
  ...ii,
  // Color props
  color: j,
  backgroundColor: j,
  outlineColor: j,
  fill: j,
  stroke: j,
  // Border props
  borderColor: j,
  borderTopColor: j,
  borderRightColor: j,
  borderBottomColor: j,
  borderLeftColor: j,
  filter: An,
  WebkitFilter: An
}, Uo = (t) => _l[t];
function Wo(t, e) {
  let n = Uo(t);
  return n !== An && (n = xt), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const Hl = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function Kl(t, e, n) {
  let i = 0, s;
  for (; i < t.length && !s; ) {
    const r = t[i];
    typeof r == "string" && !Hl.has(r) && re(r).values.length && (s = t[i]), i++;
  }
  if (s && n)
    for (const r of e)
      t[r] = Wo(n, s);
}
class Gl extends ti {
  constructor(e, n, i, s, r) {
    super(e, n, i, s, r, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: i } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let u = e[l];
      if (typeof u == "string" && (u = u.trim(), Gn(u))) {
        const c = Oo(u, n.current);
        c !== void 0 && (e[l] = c), l === e.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !No.has(i) || e.length !== 2)
      return;
    const [s, r] = e, o = Fi(s), a = Fi(r);
    if (o !== a)
      if (Li(o) && Li(a))
        for (let l = 0; l < e.length; l++) {
          const u = e[l];
          typeof u == "string" && (e[l] = parseFloat(u));
        }
      else Mt[i] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, i = [];
    for (let s = 0; s < e.length; s++)
      (e[s] === null || Nl(e[s])) && i.push(s);
    i.length && Kl(e, i, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: i } = this;
    if (!e || !e.current)
      return;
    i === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Mt[i](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const s = n[n.length - 1];
    s !== void 0 && e.getValue(i, s).jump(s, !1);
  }
  measureEndState() {
    var a;
    const { element: e, name: n, unresolvedKeyframes: i } = this;
    if (!e || !e.current)
      return;
    const s = e.getValue(n);
    s && s.jump(this.measuredOrigin, !1);
    const r = i.length - 1, o = i[r];
    i[r] = Mt[n](e.measureViewportBox(), window.getComputedStyle(e.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, u]) => {
      e.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function _o(t, e, n) {
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    let i = document;
    const s = (n == null ? void 0 : n[t]) ?? i.querySelectorAll(t);
    return s ? Array.from(s) : [];
  }
  return Array.from(t);
}
const Ho = (t, e) => e && typeof t == "number" ? e.transform(t) : t;
function Ko(t) {
  return to(t) && "offsetHeight" in t;
}
const Ni = 30, zl = (t) => !isNaN(parseFloat(t)), te = {
  current: void 0
};
class Yl {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (i) => {
      var r;
      const s = Z.now();
      if (this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(i), this.current !== this.prev && ((r = this.events.change) == null || r.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = Z.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = zl(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && $e(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Wn());
    const i = this.events[e].add(n);
    return e === "change" ? () => {
      i(), L.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : i;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, n, i) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - i;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return te.current && te.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = Z.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Ni)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Ni);
    return no(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, n;
    (e = this.dependents) == null || e.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Lt(t, e) {
  return new Yl(t, e);
}
const { schedule: si } = /* @__PURE__ */ go(queueMicrotask, !1), ot = {
  x: !1,
  y: !1
};
function Go() {
  return ot.x || ot.y;
}
function Xl(t) {
  return t === "x" || t === "y" ? ot[t] ? null : (ot[t] = !0, () => {
    ot[t] = !1;
  }) : ot.x || ot.y ? null : (ot.x = ot.y = !0, () => {
    ot.x = ot.y = !1;
  });
}
function zo(t, e) {
  const n = _o(t), i = new AbortController(), s = {
    passive: !0,
    ...e,
    signal: i.signal
  };
  return [n, s, () => i.abort()];
}
function ji(t) {
  return !(t.pointerType === "touch" || Go());
}
function ql(t, e, n = {}) {
  const [i, s, r] = zo(t, n), o = (a) => {
    if (!ji(a))
      return;
    const { target: l } = a, u = e(l, a);
    if (typeof u != "function" || !l)
      return;
    const c = (h) => {
      ji(h) && (u(h), l.removeEventListener("pointerleave", c));
    };
    l.addEventListener("pointerleave", c, s);
  };
  return i.forEach((a) => {
    a.addEventListener("pointerenter", o, s);
  }), r;
}
const Yo = (t, e) => e ? t === e ? !0 : Yo(t, e.parentElement) : !1, oi = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1, Zl = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Jl(t) {
  return Zl.has(t.tagName) || t.tabIndex !== -1;
}
const Ee = /* @__PURE__ */ new WeakSet();
function $i(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function Qe(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const Ql = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const i = $i(() => {
    if (Ee.has(n))
      return;
    Qe(n, "down");
    const s = $i(() => {
      Qe(n, "up");
    }), r = () => Qe(n, "cancel");
    n.addEventListener("keyup", s, e), n.addEventListener("blur", r, e);
  });
  n.addEventListener("keydown", i, e), n.addEventListener("blur", () => n.removeEventListener("keydown", i), e);
};
function Ui(t) {
  return oi(t) && !Go();
}
function tc(t, e, n = {}) {
  const [i, s, r] = zo(t, n), o = (a) => {
    const l = a.currentTarget;
    if (!Ui(a))
      return;
    Ee.add(l);
    const u = e(l, a), c = (d, m) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", f), Ee.has(l) && Ee.delete(l), Ui(d) && typeof u == "function" && u(d, { success: m });
    }, h = (d) => {
      c(d, l === window || l === document || n.useGlobalTarget || Yo(l, d.target));
    }, f = (d) => {
      c(d, !1);
    };
    window.addEventListener("pointerup", h, s), window.addEventListener("pointercancel", f, s);
  };
  return i.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", o, s), Ko(a) && (a.addEventListener("focus", (u) => Ql(u, s)), !Jl(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), r;
}
function ri(t) {
  return to(t) && "ownerSVGElement" in t;
}
function Xo(t) {
  return ri(t) && t.tagName === "svg";
}
function De(...t) {
  const e = !Array.isArray(t[0]), n = e ? 0 : -1, i = t[0 + n], s = t[1 + n], r = t[2 + n], o = t[3 + n], a = Eo(s, r, o);
  return e ? a(i) : a;
}
const _ = (t) => !!(t && t.getVelocity), ec = [...$o, j, xt], nc = (t) => ec.find(jo(t)), Ue = bt({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
class ic extends Bn.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (n && e.isPresent && !this.props.isPresent) {
      const i = n.offsetParent, s = Ko(i) && i.offsetWidth || 0, r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft, r.right = s - r.width - r.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function sc({ children: t, isPresent: e, anchorX: n, root: i }) {
  const s = Fn(), r = K(null), o = K({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: a } = U(Ue);
  return qs(() => {
    const { width: l, height: u, top: c, left: h, right: f } = o.current;
    if (e || !r.current || !l || !u)
      return;
    const d = n === "left" ? `left: ${h}` : `right: ${f}`;
    r.current.dataset.motionPopId = s;
    const m = document.createElement("style");
    a && (m.nonce = a);
    const g = i ?? document.head;
    return g.appendChild(m), m.sheet && m.sheet.insertRule(`
          [data-motion-pop-id="${s}"] {
            position: absolute !important;
            width: ${l}px !important;
            height: ${u}px !important;
            ${d}px !important;
            top: ${c}px !important;
          }
        `), () => {
      g.contains(m) && g.removeChild(m);
    };
  }, [e]), $(ic, { isPresent: e, childRef: r, sizeRef: o, children: Bn.cloneElement(t, { ref: r }) });
}
const oc = ({ children: t, initial: e, isPresent: n, onExitComplete: i, custom: s, presenceAffectsLayout: r, mode: o, anchorX: a, root: l }) => {
  const u = me(rc), c = Fn();
  let h = !0, f = dt(() => (h = !1, {
    id: c,
    initial: e,
    isPresent: n,
    custom: s,
    onExitComplete: (d) => {
      u.set(d, !0);
      for (const m of u.values())
        if (!m)
          return;
      i && i();
    },
    register: (d) => (u.set(d, !1), () => u.delete(d))
  }), [n, u, i]);
  return r && h && (f = { ...f }), dt(() => {
    u.forEach((d, m) => u.set(m, !1));
  }, [n]), Bn.useEffect(() => {
    !n && !u.size && i && i();
  }, [n]), o === "popLayout" && (t = $(sc, { isPresent: n, anchorX: a, root: l, children: t })), $(Ne.Provider, { value: f, children: t });
};
function rc() {
  return /* @__PURE__ */ new Map();
}
function qo(t = !0) {
  const e = U(Ne);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: i, register: s } = e, r = Fn();
  rt(() => {
    if (t)
      return s(r);
  }, [t]);
  const o = de(() => t && i && i(r), [r, i, t]);
  return !n && i ? [!1, o] : [!0];
}
const we = (t) => t.key || "";
function Wi(t) {
  const e = [];
  return Zs.forEach(t, (n) => {
    ea(n) && e.push(n);
  }), e;
}
const ac = ({ children: t, custom: e, initial: n = !0, onExitComplete: i, presenceAffectsLayout: s = !0, mode: r = "sync", propagate: o = !1, anchorX: a = "left", root: l }) => {
  const [u, c] = qo(o), h = dt(() => Wi(t), [t]), f = o && !u ? [] : h.map(we), d = K(!0), m = K(h), g = me(() => /* @__PURE__ */ new Map()), [y, p] = at(h), [v, T] = at(h);
  jn(() => {
    d.current = !1, m.current = h;
    for (let S = 0; S < v.length; S++) {
      const A = we(v[S]);
      f.includes(A) ? g.delete(A) : g.get(A) !== !0 && g.set(A, !1);
    }
  }, [v, f.length, f.join("-")]);
  const w = [];
  if (h !== y) {
    let S = [...h];
    for (let A = 0; A < v.length; A++) {
      const b = v[A], V = we(b);
      f.includes(V) || (S.splice(A, 0, b), w.push(b));
    }
    return r === "wait" && w.length && (S = w), T(Wi(S)), p(h), null;
  }
  process.env.NODE_ENV !== "production" && r === "wait" && v.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: x } = U(On);
  return $(Ys, { children: v.map((S) => {
    const A = we(S), b = o && !u ? !1 : h === v || f.includes(A), V = () => {
      if (g.has(A))
        g.set(A, !0);
      else
        return;
      let D = !0;
      g.forEach((R) => {
        R || (D = !1);
      }), D && (x == null || x(), T(m.current), o && (c == null || c()), i && i());
    };
    return $(oc, { isPresent: b, initial: !d.current || n ? void 0 : !1, custom: e, presenceAffectsLayout: s, mode: r, root: l, onExitComplete: b ? void 0 : V, anchorX: a, children: S }, A);
  }) });
}, Zo = bt({ strict: !1 }), _i = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, _t = {};
for (const t in _i)
  _t[t] = {
    isEnabled: (e) => _i[t].some((n) => !!e[n])
  };
function lc(t) {
  for (const e in t)
    _t[e] = {
      ..._t[e],
      ...t[e]
    };
}
const cc = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Ie(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || cc.has(t);
}
let Jo = (t) => !Ie(t);
function uc(t) {
  typeof t == "function" && (Jo = (e) => e.startsWith("on") ? !Ie(e) : t(e));
}
try {
  uc(require("@emotion/is-prop-valid").default);
} catch {
}
function hc(t, e, n) {
  const i = {};
  for (const s in t)
    s === "values" && typeof t.values == "object" || (Jo(s) || n === !0 && Ie(s) || !e && !Ie(s) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && s.startsWith("onDrag")) && (i[s] = t[s]);
  return i;
}
const We = /* @__PURE__ */ bt({});
function _e(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function le(t) {
  return typeof t == "string" || Array.isArray(t);
}
const ai = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], li = ["initial", ...ai];
function He(t) {
  return _e(t.animate) || li.some((e) => le(t[e]));
}
function Qo(t) {
  return !!(He(t) || t.variants);
}
function fc(t, e) {
  if (He(t)) {
    const { initial: n, animate: i } = t;
    return {
      initial: n === !1 || le(n) ? n : void 0,
      animate: le(i) ? i : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function dc(t) {
  const { initial: e, animate: n } = fc(t, U(We));
  return dt(() => ({ initial: e, animate: n }), [Hi(e), Hi(n)]);
}
function Hi(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const ce = {};
function mc(t) {
  for (const e in t)
    ce[e] = t[e], Kn(e) && (ce[e].isCSSVariable = !0);
}
function tr(t, { layout: e, layoutId: n }) {
  return zt.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!ce[t] || t === "opacity");
}
const pc = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, gc = Gt.length;
function yc(t, e, n) {
  let i = "", s = !0;
  for (let r = 0; r < gc; r++) {
    const o = Gt[r], a = t[o];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const u = Ho(a, ii[o]);
      if (!l) {
        s = !1;
        const c = pc[o] || o;
        i += `${c}(${u}) `;
      }
      n && (e[o] = u);
    }
  }
  return i = i.trim(), n ? i = n(e, s ? "" : i) : s && (i = "none"), i;
}
function ci(t, e, n) {
  const { style: i, vars: s, transformOrigin: r } = t;
  let o = !1, a = !1;
  for (const l in e) {
    const u = e[l];
    if (zt.has(l)) {
      o = !0;
      continue;
    } else if (Kn(l)) {
      s[l] = u;
      continue;
    } else {
      const c = Ho(u, ii[l]);
      l.startsWith("origin") ? (a = !0, r[l] = c) : i[l] = c;
    }
  }
  if (e.transform || (o || n ? i.transform = yc(e, t.transform, n) : i.transform && (i.transform = "none")), a) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = r;
    i.transformOrigin = `${l} ${u} ${c}`;
  }
}
const ui = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function er(t, e, n) {
  for (const i in e)
    !_(e[i]) && !tr(i, n) && (t[i] = e[i]);
}
function vc({ transformTemplate: t }, e) {
  return dt(() => {
    const n = ui();
    return ci(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function Tc(t, e) {
  const n = t.style || {}, i = {};
  return er(i, n, t), Object.assign(i, vc(t, e)), i;
}
function xc(t, e) {
  const n = {}, i = Tc(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = i, n;
}
const bc = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Sc = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function wc(t, e, n = 1, i = 0, s = !0) {
  t.pathLength = 1;
  const r = s ? bc : Sc;
  t[r.offset] = P.transform(-i);
  const o = P.transform(e), a = P.transform(n);
  t[r.array] = `${o} ${a}`;
}
function nr(t, {
  attrX: e,
  attrY: n,
  attrScale: i,
  pathLength: s,
  pathSpacing: r = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, u, c) {
  if (ci(t, a, u), l) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: h, style: f } = t;
  h.transform && (f.transform = h.transform, delete h.transform), (f.transform || h.transformOrigin) && (f.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), f.transform && (f.transformBox = (c == null ? void 0 : c.transformBox) ?? "fill-box", delete h.transformBox), e !== void 0 && (h.x = e), n !== void 0 && (h.y = n), i !== void 0 && (h.scale = i), s !== void 0 && wc(h, s, r, o, !1);
}
const ir = () => ({
  ...ui(),
  attrs: {}
}), sr = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function Pc(t, e, n, i) {
  const s = dt(() => {
    const r = ir();
    return nr(r, e, sr(i), t.transformTemplate, t.style), {
      ...r.attrs,
      style: { ...r.style }
    };
  }, [e]);
  if (t.style) {
    const r = {};
    er(r, t.style, t), s.style = { ...r, ...s.style };
  }
  return s;
}
const Ac = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function hi(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Ac.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function Vc(t, e, n, { latestValues: i }, s, r = !1) {
  const a = (hi(t) ? Pc : xc)(e, i, s, t), l = hc(e, typeof t == "string", r), u = t !== Js ? { ...l, ...a, ref: n } : {}, { children: c } = e, h = dt(() => _(c) ? c.get() : c, [c]);
  return na(t, {
    ...u,
    children: h
  });
}
function Ki(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, i) => {
    e[0][i] = n.get(), e[1][i] = n.getVelocity();
  }), e;
}
function fi(t, e, n, i) {
  if (typeof e == "function") {
    const [s, r] = Ki(i);
    e = e(n !== void 0 ? n : t.custom, s, r);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [s, r] = Ki(i);
    e = e(n !== void 0 ? n : t.custom, s, r);
  }
  return e;
}
function Me(t) {
  return _(t) ? t.get() : t;
}
function Cc({ scrapeMotionValuesFromProps: t, createRenderState: e }, n, i, s) {
  return {
    latestValues: Ec(n, i, s, t),
    renderState: e()
  };
}
function Ec(t, e, n, i) {
  const s = {}, r = i(t, {});
  for (const f in r)
    s[f] = Me(r[f]);
  let { initial: o, animate: a } = t;
  const l = He(t), u = Qo(t);
  e && u && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), a === void 0 && (a = e.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || o === !1;
  const h = c ? a : o;
  if (h && typeof h != "boolean" && !_e(h)) {
    const f = Array.isArray(h) ? h : [h];
    for (let d = 0; d < f.length; d++) {
      const m = fi(t, f[d]);
      if (m) {
        const { transitionEnd: g, transition: y, ...p } = m;
        for (const v in p) {
          let T = p[v];
          if (Array.isArray(T)) {
            const w = c ? T.length - 1 : 0;
            T = T[w];
          }
          T !== null && (s[v] = T);
        }
        for (const v in g)
          s[v] = g[v];
      }
    }
  }
  return s;
}
const or = (t) => (e, n) => {
  const i = U(We), s = U(Ne), r = () => Cc(t, e, i, s);
  return n ? r() : me(r);
};
function di(t, e, n) {
  var r;
  const { style: i } = t, s = {};
  for (const o in i)
    (_(i[o]) || e.style && _(e.style[o]) || tr(o, t) || ((r = n == null ? void 0 : n.getValue(o)) == null ? void 0 : r.liveStyle) !== void 0) && (s[o] = i[o]);
  return s;
}
const Dc = /* @__PURE__ */ or({
  scrapeMotionValuesFromProps: di,
  createRenderState: ui
});
function rr(t, e, n) {
  const i = di(t, e, n);
  for (const s in t)
    if (_(t[s]) || _(e[s])) {
      const r = Gt.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
      i[r] = t[s];
    }
  return i;
}
const Mc = /* @__PURE__ */ or({
  scrapeMotionValuesFromProps: rr,
  createRenderState: ir
}), Rc = Symbol.for("motionComponentSymbol");
function Ot(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function Lc(t, e, n) {
  return de(
    (i) => {
      i && t.onMount && t.onMount(i), e && (i ? e.mount(i) : e.unmount()), n && (typeof n == "function" ? n(i) : Ot(n) && (n.current = i));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const mi = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), kc = "framerAppearId", ar = "data-" + mi(kc), lr = bt({});
function Ic(t, e, n, i, s) {
  var g, y;
  const { visualElement: r } = U(We), o = U(Zo), a = U(Ne), l = U(Ue).reducedMotion, u = K(null);
  i = i || o.renderer, !u.current && i && (u.current = i(t, {
    visualState: e,
    parent: r,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const c = u.current, h = U(lr);
  c && !c.projection && s && (c.type === "html" || c.type === "svg") && Bc(u.current, n, s, h);
  const f = K(!1);
  qs(() => {
    c && f.current && c.update(n, a);
  });
  const d = n[ar], m = K(!!d && !((g = window.MotionHandoffIsComplete) != null && g.call(window, d)) && ((y = window.MotionHasOptimisedAnimation) == null ? void 0 : y.call(window, d)));
  return jn(() => {
    c && (f.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), c.scheduleRenderMicrotask(), m.current && c.animationState && c.animationState.animateChanges());
  }), rt(() => {
    c && (!m.current && c.animationState && c.animationState.animateChanges(), m.current && (queueMicrotask(() => {
      var p;
      (p = window.MotionHandoffMarkAsComplete) == null || p.call(window, d);
    }), m.current = !1), c.enteringChildren = void 0);
  }), c;
}
function Bc(t, e, n, i) {
  const { layoutId: s, layout: r, drag: o, dragConstraints: a, layoutScroll: l, layoutRoot: u, layoutCrossfade: c } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : cr(t.parent)), t.projection.setOptions({
    layoutId: s,
    layout: r,
    alwaysMeasureLayout: !!o || a && Ot(a),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof r == "string" ? r : "both",
    initialPromotionConfig: i,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: u
  });
}
function cr(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : cr(t.parent);
}
function tn(t, { forwardMotionProps: e = !1 } = {}, n, i) {
  n && lc(n);
  const s = hi(t) ? Mc : Dc;
  function r(a, l) {
    let u;
    const c = {
      ...U(Ue),
      ...a,
      layoutId: Fc(a)
    }, { isStatic: h } = c, f = dc(a), d = s(a, h);
    if (!h && Nn) {
      Oc(c, n);
      const m = Nc(c);
      u = m.MeasureLayout, f.visualElement = Ic(t, d, c, i, m.ProjectionNode);
    }
    return Zt(We.Provider, { value: f, children: [u && f.visualElement ? $(u, { visualElement: f.visualElement, ...c }) : null, Vc(t, a, Lc(d, f.visualElement, l), d, h, e)] });
  }
  r.displayName = `motion.${typeof t == "string" ? t : `create(${t.displayName ?? t.name ?? ""})`}`;
  const o = kt(r);
  return o[Rc] = t, o;
}
function Fc({ layoutId: t }) {
  const e = U(On).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function Oc(t, e) {
  const n = U(Zo).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const i = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? Ht(!1, i, "lazy-strict-mode") : it(!1, i, "lazy-strict-mode");
  }
}
function Nc(t) {
  const { drag: e, layout: n } = _t;
  if (!e && !n)
    return {};
  const i = { ...e, ...n };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || n != null && n.isEnabled(t) ? i.MeasureLayout : void 0,
    ProjectionNode: i.ProjectionNode
  };
}
function jc(t, e) {
  if (typeof Proxy > "u")
    return tn;
  const n = /* @__PURE__ */ new Map(), i = (r, o) => tn(r, o, t, e), s = (r, o) => (process.env.NODE_ENV !== "production" && $e(!1, "motion() is deprecated. Use motion.create() instead."), i(r, o));
  return new Proxy(s, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => o === "create" ? i : (n.has(o) || n.set(o, tn(o, void 0, t, e)), n.get(o))
  });
}
function ur({ top: t, left: e, right: n, bottom: i }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: i }
  };
}
function $c({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function Uc(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), i = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: i.y,
    right: i.x
  };
}
function en(t) {
  return t === void 0 || t === 1;
}
function Vn({ scale: t, scaleX: e, scaleY: n }) {
  return !en(t) || !en(e) || !en(n);
}
function Ct(t) {
  return Vn(t) || hr(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function hr(t) {
  return Gi(t.x) || Gi(t.y);
}
function Gi(t) {
  return t && t !== "0%";
}
function Be(t, e, n) {
  const i = t - n, s = e * i;
  return n + s;
}
function zi(t, e, n, i, s) {
  return s !== void 0 && (t = Be(t, s, i)), Be(t, n, i) + e;
}
function Cn(t, e = 0, n = 1, i, s) {
  t.min = zi(t.min, e, n, i, s), t.max = zi(t.max, e, n, i, s);
}
function fr(t, { x: e, y: n }) {
  Cn(t.x, e.translate, e.scale, e.originPoint), Cn(t.y, n.translate, n.scale, n.originPoint);
}
const Yi = 0.999999999999, Xi = 1.0000000000001;
function Wc(t, e, n, i = !1) {
  const s = n.length;
  if (!s)
    return;
  e.x = e.y = 1;
  let r, o;
  for (let a = 0; a < s; a++) {
    r = n[a], o = r.projectionDelta;
    const { visualElement: l } = r.options;
    l && l.props.style && l.props.style.display === "contents" || (i && r.options.layoutScroll && r.scroll && r !== r.root && jt(t, {
      x: -r.scroll.offset.x,
      y: -r.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, fr(t, o)), i && Ct(r.latestValues) && jt(t, r.latestValues));
  }
  e.x < Xi && e.x > Yi && (e.x = 1), e.y < Xi && e.y > Yi && (e.y = 1);
}
function Nt(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function qi(t, e, n, i, s = 0.5) {
  const r = k(t.min, t.max, s);
  Cn(t, e, n, r, i);
}
function jt(t, e) {
  qi(t.x, e.x, e.scaleX, e.scale, e.originX), qi(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function dr(t, e) {
  return ur(Uc(t.getBoundingClientRect(), e));
}
function _c(t, e, n) {
  const i = dr(t, n), { scroll: s } = e;
  return s && (Nt(i.x, s.offset.x), Nt(i.y, s.offset.y)), i;
}
const Zi = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), $t = () => ({
  x: Zi(),
  y: Zi()
}), Ji = () => ({ min: 0, max: 0 }), F = () => ({
  x: Ji(),
  y: Ji()
}), Fe = { current: null }, pi = { current: !1 };
function mr() {
  if (pi.current = !0, !!Nn)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => Fe.current = t.matches;
      t.addEventListener("change", e), e();
    } else
      Fe.current = !1;
}
const ue = /* @__PURE__ */ new WeakMap();
function Hc(t, e, n) {
  for (const i in e) {
    const s = e[i], r = n[i];
    if (_(s))
      t.addValue(i, s);
    else if (_(r))
      t.addValue(i, Lt(s, { owner: t }));
    else if (r !== s)
      if (t.hasValue(i)) {
        const o = t.getValue(i);
        o.liveStyle === !0 ? o.jump(s) : o.hasAnimated || o.set(s);
      } else {
        const o = t.getStaticValue(i);
        t.addValue(i, Lt(o !== void 0 ? o : s, { owner: t }));
      }
  }
  for (const i in n)
    e[i] === void 0 && t.removeValue(i);
  return e;
}
const Qi = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class pr {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, i) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: i, reducedMotionConfig: s, blockInitialAnimation: r, visualState: o }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = ti, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = Z.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, L.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = e, this.props = n, this.presenceContext = i, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = s, this.options = a, this.blockInitialAnimation = !!r, this.isControllingVariants = He(n), this.isVariantNode = Qo(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: c, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in h) {
      const d = h[f];
      l[f] !== void 0 && _(d) && d.set(l[f]);
    }
  }
  mount(e) {
    var n;
    this.current = e, ue.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((i, s) => this.bindToMotionValue(s, i)), pi.current || mr(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Fe.current, process.env.NODE_ENV !== "production" && $e(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (n = this.parent) == null || n.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var e;
    this.projection && this.projection.unmount(), gt(this.notifyUpdate), gt(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (e = this.parent) == null || e.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const i = this.features[n];
      i && (i.unmount(), i.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const i = zt.has(e);
    i && this.onBindTransform && this.onBindTransform();
    const s = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && L.preRender(this.notifyUpdate), i && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let r;
    window.MotionCheckAppearSync && (r = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      s(), r && r(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in _t) {
      const n = _t[e];
      if (!n)
        continue;
      const { isEnabled: i, Feature: s } = n;
      if (!this.features[e] && s && i(this.props) && (this.features[e] = new s(this)), this.features[e]) {
        const r = this.features[e];
        r.isMounted ? r.update() : (r.mount(), r.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : F();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let i = 0; i < Qi.length; i++) {
      const s = Qi[i];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const r = "on" + s, o = e[r];
      o && (this.propEventSubscriptions[s] = this.on(s, o));
    }
    this.prevMotionValues = Hc(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const i = this.values.get(e);
    n !== i && (i && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let i = this.values.get(e);
    return i === void 0 && n !== void 0 && (i = Lt(n === null ? void 0 : n, { owner: this }), this.addValue(e, i)), i;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (Qs(i) || eo(i)) ? i = parseFloat(i) : !nc(i) && xt.test(n) && (i = Wo(e, n)), this.setBaseTarget(e, _(i) ? i.get() : i)), _(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var r;
    const { initial: n } = this.props;
    let i;
    if (typeof n == "string" || typeof n == "object") {
      const o = fi(this.props, n, (r = this.presenceContext) == null ? void 0 : r.custom);
      o && (i = o[e]);
    }
    if (n && i !== void 0)
      return i;
    const s = this.getBaseTargetFromProps(this.props, e);
    return s !== void 0 && !_(s) ? s : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Wn()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
  scheduleRenderMicrotask() {
    si.render(this.render);
  }
}
class gr extends pr {
  constructor() {
    super(...arguments), this.KeyframeResolver = Gl;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: i }) {
    delete n[e], delete i[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    _(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function yr(t, { style: e, vars: n }, i, s) {
  const r = t.style;
  let o;
  for (o in e)
    r[o] = e[o];
  s == null || s.applyProjectionStyles(r, i);
  for (o in n)
    r.setProperty(o, n[o]);
}
function Kc(t) {
  return window.getComputedStyle(t);
}
class vr extends gr {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = yr;
  }
  readValueFromInstance(e, n) {
    var i;
    if (zt.has(n))
      return (i = this.projection) != null && i.isProjecting ? Tn(n) : ll(e, n);
    {
      const s = Kc(e), r = (Kn(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return dr(e, n);
  }
  build(e, n, i) {
    ci(e, n, i.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, i) {
    return di(e, n, i);
  }
}
const Tr = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Gc(t, e, n, i) {
  yr(t, e, void 0, i);
  for (const s in e.attrs)
    t.setAttribute(Tr.has(s) ? s : mi(s), e.attrs[s]);
}
class xr extends gr {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = F;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (zt.has(n)) {
      const i = Uo(n);
      return i && i.default || 0;
    }
    return n = Tr.has(n) ? n : mi(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, i) {
    return rr(e, n, i);
  }
  build(e, n, i) {
    nr(e, n, this.isSVGTag, i.transformTemplate, i.style);
  }
  renderInstance(e, n, i, s) {
    Gc(e, n, i, s);
  }
  mount(e) {
    this.isSVGTag = sr(e.tagName), super.mount(e);
  }
}
const zc = (t, e) => hi(t) ? new xr(e) : new vr(e, {
  allowProjection: t !== Js
});
function Ut(t, e, n) {
  const i = t.getProps();
  return fi(i, e, n !== void 0 ? n : i.custom, t);
}
const En = (t) => Array.isArray(t);
function Yc(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, Lt(n));
}
function Xc(t) {
  return En(t) ? t[t.length - 1] || 0 : t;
}
function qc(t, e) {
  const n = Ut(t, e);
  let { transitionEnd: i = {}, transition: s = {}, ...r } = n || {};
  r = { ...r, ...i };
  for (const o in r) {
    const a = Xc(r[o]);
    Yc(t, o, a);
  }
}
function Zc(t) {
  return !!(_(t) && t.add);
}
function Dn(t, e) {
  const n = t.getValue("willChange");
  if (Zc(n))
    return n.add(e);
  if (!n && pt.WillChange) {
    const i = new pt.WillChange("auto");
    t.addValue("willChange", i), i.add(e);
  }
}
function br(t) {
  return t.props[ar];
}
const Jc = (t) => t !== null;
function Qc(t, { repeat: e, repeatType: n = "loop" }, i) {
  const s = t.filter(Jc), r = e && n !== "loop" && e % 2 === 1 ? 0 : s.length - 1;
  return s[r];
}
const tu = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, eu = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), nu = {
  type: "keyframes",
  duration: 0.8
}, iu = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, su = (t, { keyframes: e }) => e.length > 2 ? nu : zt.has(t) ? t.startsWith("scale") ? eu(e[1]) : tu : iu;
function ou({ when: t, delay: e, delayChildren: n, staggerChildren: i, staggerDirection: s, repeat: r, repeatType: o, repeatDelay: a, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const gi = (t, e, n, i = {}, s, r) => (o) => {
  const a = ni(i, t) || {}, l = a.delay || i.delay || 0;
  let { elapsed: u = 0 } = i;
  u = u - /* @__PURE__ */ nt(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (f) => {
      e.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: r ? void 0 : s
  };
  ou(a) || Object.assign(c, su(t, c)), c.duration && (c.duration = /* @__PURE__ */ nt(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ nt(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let h = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (Pn(c), c.delay === 0 && (h = !0)), (pt.instantAnimations || pt.skipAnimations) && (h = !0, Pn(c), c.delay = 0), c.allowFlatten = !a.type && !a.ease, h && !r && e.get() !== void 0) {
    const f = Qc(c.keyframes, a);
    if (f !== void 0) {
      L.update(() => {
        c.onUpdate(f), c.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new Qn(c) : new Rl(c);
};
function ru({ protectedKeys: t, needsAnimating: e }, n) {
  const i = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, i;
}
function yi(t, e, { delay: n = 0, transitionOverride: i, type: s } = {}) {
  let { transition: r = t.getDefaultTransition(), transitionEnd: o, ...a } = e;
  i && (r = i);
  const l = [], u = s && t.animationState && t.animationState.getState()[s];
  for (const c in a) {
    const h = t.getValue(c, t.latestValues[c] ?? null), f = a[c];
    if (f === void 0 || u && ru(u, c))
      continue;
    const d = {
      delay: n,
      ...ni(r || {}, c)
    }, m = h.get();
    if (m !== void 0 && !h.isAnimating && !Array.isArray(f) && f === m && !d.velocity)
      continue;
    let g = !1;
    if (window.MotionHandoffAnimation) {
      const p = br(t);
      if (p) {
        const v = window.MotionHandoffAnimation(p, c, L);
        v !== null && (d.startTime = v, g = !0);
      }
    }
    Dn(t, c), h.start(gi(c, h, f, t.shouldReduceMotion && No.has(c) ? { type: !1 } : d, t, g));
    const y = h.animation;
    y && l.push(y);
  }
  return o && Promise.all(l).then(() => {
    L.update(() => {
      o && qc(t, o);
    });
  }), l;
}
function Sr(t, e, n, i = 0, s = 1) {
  const r = Array.from(t).sort((u, c) => u.sortNodePosition(c)).indexOf(e), o = t.size, a = (o - 1) * i;
  return typeof n == "function" ? n(r, o) : s === 1 ? r * i : a - r * i;
}
function Mn(t, e, n = {}) {
  var l;
  const i = Ut(t, e, n.type === "exit" ? (l = t.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: s = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (s = n.transitionOverride);
  const r = i ? () => Promise.all(yi(t, i, n)) : () => Promise.resolve(), o = t.variantChildren && t.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: h, staggerDirection: f } = s;
    return au(t, e, u, c, h, f, n);
  } : () => Promise.resolve(), { when: a } = s;
  if (a) {
    const [u, c] = a === "beforeChildren" ? [r, o] : [o, r];
    return u().then(() => c());
  } else
    return Promise.all([r(), o(n.delay)]);
}
function au(t, e, n = 0, i = 0, s = 0, r = 1, o) {
  const a = [];
  for (const l of t.variantChildren)
    l.notify("AnimationStart", e), a.push(Mn(l, e, {
      ...o,
      delay: n + (typeof i == "function" ? 0 : i) + Sr(t.variantChildren, l, i, s, r)
    }).then(() => l.notify("AnimationComplete", e)));
  return Promise.all(a);
}
function lu(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let i;
  if (Array.isArray(e)) {
    const s = e.map((r) => Mn(t, r, n));
    i = Promise.all(s);
  } else if (typeof e == "string")
    i = Mn(t, e, n);
  else {
    const s = typeof e == "function" ? Ut(t, e, n.custom) : e;
    i = Promise.all(yi(t, s, n));
  }
  return i.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function wr(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let i = 0; i < n; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
const cu = li.length;
function Pr(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? Pr(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < cu; n++) {
    const i = li[n], s = t.props[i];
    (le(s) || s === !1) && (e[i] = s);
  }
  return e;
}
const uu = [...ai].reverse(), hu = ai.length;
function fu(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: i }) => lu(t, n, i)));
}
function du(t) {
  let e = fu(t), n = ts(), i = !0;
  const s = (l) => (u, c) => {
    var f;
    const h = Ut(t, c, l === "exit" ? (f = t.presenceContext) == null ? void 0 : f.custom : void 0);
    if (h) {
      const { transition: d, transitionEnd: m, ...g } = h;
      u = { ...u, ...g, ...m };
    }
    return u;
  };
  function r(l) {
    e = l(t);
  }
  function o(l) {
    const { props: u } = t, c = Pr(t.parent) || {}, h = [], f = /* @__PURE__ */ new Set();
    let d = {}, m = 1 / 0;
    for (let y = 0; y < hu; y++) {
      const p = uu[y], v = n[p], T = u[p] !== void 0 ? u[p] : c[p], w = le(T), x = p === l ? v.isActive : null;
      x === !1 && (m = y);
      let S = T === c[p] && T !== u[p] && w;
      if (S && i && t.manuallyAnimateOnMount && (S = !1), v.protectedKeys = { ...d }, // If it isn't active and hasn't *just* been set as inactive
      !v.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !T && !v.prevProp || // Or if the prop doesn't define an animation
      _e(T) || typeof T == "boolean")
        continue;
      const A = mu(v.prevProp, T);
      let b = A || // If we're making this variant active, we want to always make it active
      p === l && v.isActive && !S && w || // If we removed a higher-priority variant (i is in reverse order)
      y > m && w, V = !1;
      const D = Array.isArray(T) ? T : [T];
      let R = D.reduce(s(p), {});
      x === !1 && (R = {});
      const { prevResolvedValues: N = {} } = v, st = {
        ...N,
        ...R
      }, wt = (E) => {
        b = !0, f.has(E) && (V = !0, f.delete(E)), v.needsAnimating[E] = !0;
        const M = t.getValue(E);
        M && (M.liveStyle = !1);
      };
      for (const E in st) {
        const M = R[E], X = N[E];
        if (d.hasOwnProperty(E))
          continue;
        let G = !1;
        En(M) && En(X) ? G = !wr(M, X) : G = M !== X, G ? M != null ? wt(E) : f.add(E) : M !== void 0 && f.has(E) ? wt(E) : v.protectedKeys[E] = !0;
      }
      v.prevProp = T, v.prevResolvedValues = R, v.isActive && (d = { ...d, ...R }), i && t.blockInitialAnimation && (b = !1);
      const yt = S && A;
      b && (!yt || V) && h.push(...D.map((E) => {
        const M = { type: p };
        if (typeof E == "string" && i && !yt && t.manuallyAnimateOnMount && t.parent) {
          const { parent: X } = t, G = Ut(X, E);
          if (X.enteringChildren && G) {
            const { delayChildren: ut } = G.transition || {};
            M.delay = Sr(X.enteringChildren, t, ut);
          }
        }
        return {
          animation: E,
          options: M
        };
      }));
    }
    if (f.size) {
      const y = {};
      if (typeof u.initial != "boolean") {
        const p = Ut(t, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        p && p.transition && (y.transition = p.transition);
      }
      f.forEach((p) => {
        const v = t.getBaseTarget(p), T = t.getValue(p);
        T && (T.liveStyle = !0), y[p] = v ?? null;
      }), h.push({ animation: y });
    }
    let g = !!h.length;
    return i && (u.initial === !1 || u.initial === u.animate) && !t.manuallyAnimateOnMount && (g = !1), i = !1, g ? e(h) : Promise.resolve();
  }
  function a(l, u) {
    var h;
    if (n[l].isActive === u)
      return Promise.resolve();
    (h = t.variantChildren) == null || h.forEach((f) => {
      var d;
      return (d = f.animationState) == null ? void 0 : d.setActive(l, u);
    }), n[l].isActive = u;
    const c = o(l);
    for (const f in n)
      n[f].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: o,
    setActive: a,
    setAnimateFunction: r,
    getState: () => n,
    reset: () => {
      n = ts(), i = !0;
    }
  };
}
function mu(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !wr(e, t) : !1;
}
function At(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function ts() {
  return {
    animate: At(!0),
    whileInView: At(),
    whileHover: At(),
    whileTap: At(),
    whileDrag: At(),
    whileFocus: At(),
    exit: At()
  };
}
class St {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class pu extends St {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = du(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    _e(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let gu = 0;
class yu extends St {
  constructor() {
    super(...arguments), this.id = gu++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: i } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === i)
      return;
    const s = this.node.animationState.setActive("exit", !e);
    n && !e && s.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const vu = {
  animation: {
    Feature: pu
  },
  exit: {
    Feature: yu
  }
};
function he(t, e, n, i = { passive: !0 }) {
  return t.addEventListener(e, n, i), () => t.removeEventListener(e, n);
}
function ve(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const Tu = (t) => (e) => oi(e) && t(e, ve(e));
function ee(t, e, n, i) {
  return he(t, e, Tu(n), i);
}
const Ar = 1e-4, xu = 1 - Ar, bu = 1 + Ar, Vr = 0.01, Su = 0 - Vr, wu = 0 + Vr;
function Y(t) {
  return t.max - t.min;
}
function Pu(t, e, n) {
  return Math.abs(t - e) <= n;
}
function es(t, e, n, i = 0.5) {
  t.origin = i, t.originPoint = k(e.min, e.max, t.origin), t.scale = Y(n) / Y(e), t.translate = k(n.min, n.max, t.origin) - t.originPoint, (t.scale >= xu && t.scale <= bu || isNaN(t.scale)) && (t.scale = 1), (t.translate >= Su && t.translate <= wu || isNaN(t.translate)) && (t.translate = 0);
}
function ne(t, e, n, i) {
  es(t.x, e.x, n.x, i ? i.originX : void 0), es(t.y, e.y, n.y, i ? i.originY : void 0);
}
function ns(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + Y(e);
}
function Au(t, e, n) {
  ns(t.x, e.x, n.x), ns(t.y, e.y, n.y);
}
function is(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + Y(e);
}
function ie(t, e, n) {
  is(t.x, e.x, n.x), is(t.y, e.y, n.y);
}
function tt(t) {
  return [t("x"), t("y")];
}
const Cr = ({ current: t }) => t ? t.ownerDocument.defaultView : null, ss = (t, e) => Math.abs(t - e);
function Vu(t, e) {
  const n = ss(t.x, e.x), i = ss(t.y, e.y);
  return Math.sqrt(n ** 2 + i ** 2);
}
class Er {
  constructor(e, n, { transformPagePoint: i, contextWindow: s = window, dragSnapToOrigin: r = !1, distanceThreshold: o = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = sn(this.lastMoveEventInfo, this.history), d = this.startEvent !== null, m = Vu(f.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!d && !m)
        return;
      const { point: g } = f, { timestamp: y } = H;
      this.history.push({ ...g, timestamp: y });
      const { onStart: p, onMove: v } = this.handlers;
      d || (p && p(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), v && v(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, d) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = nn(d, this.transformPagePoint), L.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, d) => {
      this.end();
      const { onEnd: m, onSessionEnd: g, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const p = sn(f.type === "pointercancel" ? this.lastMoveEventInfo : nn(d, this.transformPagePoint), this.history);
      this.startEvent && m && m(f, p), g && g(f, p);
    }, !oi(e))
      return;
    this.dragSnapToOrigin = r, this.handlers = n, this.transformPagePoint = i, this.distanceThreshold = o, this.contextWindow = s || window;
    const a = ve(e), l = nn(a, this.transformPagePoint), { point: u } = l, { timestamp: c } = H;
    this.history = [{ ...u, timestamp: c }];
    const { onSessionStart: h } = n;
    h && h(e, sn(l, this.history)), this.removeListeners = pe(ee(this.contextWindow, "pointermove", this.handlePointerMove), ee(this.contextWindow, "pointerup", this.handlePointerUp), ee(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), gt(this.updatePoint);
  }
}
function nn(t, e) {
  return e ? { point: e(t.point) } : t;
}
function os(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function sn({ point: t }, e) {
  return {
    point: t,
    delta: os(t, Dr(e)),
    offset: os(t, Cu(e)),
    velocity: Eu(e, 0.1)
  };
}
function Cu(t) {
  return t[0];
}
function Dr(t) {
  return t[t.length - 1];
}
function Eu(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, i = null;
  const s = Dr(t);
  for (; n >= 0 && (i = t[n], !(s.timestamp - i.timestamp > /* @__PURE__ */ nt(e))); )
    n--;
  if (!i)
    return { x: 0, y: 0 };
  const r = /* @__PURE__ */ lt(s.timestamp - i.timestamp);
  if (r === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (s.x - i.x) / r,
    y: (s.y - i.y) / r
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function Du(t, { min: e, max: n }, i) {
  return e !== void 0 && t < e ? t = i ? k(e, t, i.min) : Math.max(t, e) : n !== void 0 && t > n && (t = i ? k(n, t, i.max) : Math.min(t, n)), t;
}
function rs(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Mu(t, { top: e, left: n, bottom: i, right: s }) {
  return {
    x: rs(t.x, n, s),
    y: rs(t.y, e, i)
  };
}
function as(t, e) {
  let n = e.min - t.min, i = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, i] = [i, n]), { min: n, max: i };
}
function Ru(t, e) {
  return {
    x: as(t.x, e.x),
    y: as(t.y, e.y)
  };
}
function Lu(t, e) {
  let n = 0.5;
  const i = Y(t), s = Y(e);
  return s > i ? n = /* @__PURE__ */ Wt(e.min, e.max - i, t.min) : i > s && (n = /* @__PURE__ */ Wt(t.min, t.max - s, e.min)), mt(0, 1, n);
}
function ku(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const Rn = 0.35;
function Iu(t = Rn) {
  return t === !1 ? t = 0 : t === !0 && (t = Rn), {
    x: ls(t, "left", "right"),
    y: ls(t, "top", "bottom")
  };
}
function ls(t, e, n) {
  return {
    min: cs(t, e),
    max: cs(t, n)
  };
}
function cs(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const Bu = /* @__PURE__ */ new WeakMap();
class Fu {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = F(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1, distanceThreshold: i } = {}) {
    const { presenceContext: s } = this.visualElement;
    if (s && s.isPresent === !1)
      return;
    const r = (h) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(ve(h).point);
    }, o = (h, f) => {
      const { drag: d, dragPropagation: m, onDragStart: g } = this.getProps();
      if (d && !m && (this.openDragLock && this.openDragLock(), this.openDragLock = Xl(d), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), tt((p) => {
        let v = this.getAxisMotionValue(p).get() || 0;
        if (ct.test(v)) {
          const { projection: T } = this.visualElement;
          if (T && T.layout) {
            const w = T.layout.layoutBox[p];
            w && (v = Y(w) * (parseFloat(v) / 100));
          }
        }
        this.originPoint[p] = v;
      }), g && L.postRender(() => g(h, f)), Dn(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, a = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f;
      const { dragPropagation: d, dragDirectionLock: m, onDirectionLock: g, onDrag: y } = this.getProps();
      if (!d && !this.openDragLock)
        return;
      const { offset: p } = f;
      if (m && this.currentDirection === null) {
        this.currentDirection = Ou(p), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, p), this.updateAxis("y", f.point, p), this.visualElement.render(), y && y(h, f);
    }, l = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f, this.stop(h, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => tt((h) => {
      var f;
      return this.getAnimationState(h) === "paused" && ((f = this.getAxisMotionValue(h).animation) == null ? void 0 : f.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new Er(e, {
      onSessionStart: r,
      onStart: o,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: i,
      contextWindow: Cr(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(e, n) {
    const i = e || this.latestPointerEvent, s = n || this.latestPanInfo, r = this.isDragging;
    if (this.cancel(), !r || !s || !i)
      return;
    const { velocity: o } = s;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && L.postRender(() => a(i, s));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: i } = this.getProps();
    !i && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, i) {
    const { drag: s } = this.getProps();
    if (!i || !Pe(e, s, this.currentDirection))
      return;
    const r = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + i[e];
    this.constraints && this.constraints[e] && (o = Du(o, this.constraints[e], this.elastic[e])), r.set(o);
  }
  resolveConstraints() {
    var r;
    const { dragConstraints: e, dragElastic: n } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (r = this.visualElement.projection) == null ? void 0 : r.layout, s = this.constraints;
    e && Ot(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && i ? this.constraints = Mu(i.layoutBox, e) : this.constraints = !1, this.elastic = Iu(n), s !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && tt((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = ku(i.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !Ot(e))
      return !1;
    const i = e.current;
    it(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: s } = this.visualElement;
    if (!s || !s.layout)
      return !1;
    const r = _c(i, s.root, this.visualElement.getTransformPagePoint());
    let o = Ru(s.layout.layoutBox, r);
    if (n) {
      const a = n($c(o));
      this.hasMutatedConstraints = !!a, a && (o = ur(a));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: i, dragElastic: s, dragTransition: r, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, u = tt((c) => {
      if (!Pe(c, n, this.currentDirection))
        return;
      let h = l && l[c] || {};
      o && (h = { min: 0, max: 0 });
      const f = s ? 200 : 1e6, d = s ? 40 : 1e7, m = {
        type: "inertia",
        velocity: i ? e[c] : 0,
        bounceStiffness: f,
        bounceDamping: d,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...r,
        ...h
      };
      return this.startAxisValueAnimation(c, m);
    });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(e, n) {
    const i = this.getAxisMotionValue(e);
    return Dn(this.visualElement, e), i.start(gi(e, i, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    tt((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    tt((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, i = this.visualElement.getProps(), s = i[n];
    return s || this.visualElement.getValue(e, (i.initial ? i.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    tt((n) => {
      const { drag: i } = this.getProps();
      if (!Pe(n, i, this.currentDirection))
        return;
      const { projection: s } = this.visualElement, r = this.getAxisMotionValue(n);
      if (s && s.layout) {
        const { min: o, max: a } = s.layout.layoutBox[n];
        r.set(e[n] - k(o, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: i } = this.visualElement;
    if (!Ot(n) || !i || !this.constraints)
      return;
    this.stopAnimation();
    const s = { x: 0, y: 0 };
    tt((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const l = a.get();
        s[o] = Lu({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: r } = this.visualElement.getProps();
    this.visualElement.current.style.transform = r ? r({}, "") : "none", i.root && i.root.updateScroll(), i.updateLayout(), this.resolveConstraints(), tt((o) => {
      if (!Pe(o, e, null))
        return;
      const a = this.getAxisMotionValue(o), { min: l, max: u } = this.constraints[o];
      a.set(k(l, u, s[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Bu.set(this.visualElement, this);
    const e = this.visualElement.current, n = ee(e, "pointerdown", (l) => {
      const { drag: u, dragListener: c = !0 } = this.getProps();
      u && c && this.start(l);
    }), i = () => {
      const { dragConstraints: l } = this.getProps();
      Ot(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: s } = this.visualElement, r = s.addEventListener("measure", i);
    s && !s.layout && (s.root && s.root.updateScroll(), s.updateLayout()), L.read(i);
    const o = he(window, "resize", () => this.scalePositionWithinConstraints()), a = s.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: u }) => {
      this.isDragging && u && (tt((c) => {
        const h = this.getAxisMotionValue(c);
        h && (this.originPoint[c] += l[c].translate, h.set(h.get() + l[c].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), r(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: i = !1, dragPropagation: s = !1, dragConstraints: r = !1, dragElastic: o = Rn, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: i,
      dragPropagation: s,
      dragConstraints: r,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function Pe(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function Ou(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class Nu extends St {
  constructor(e) {
    super(e), this.removeGroupControls = et, this.removeListeners = et, this.controls = new Fu(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || et;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const us = (t) => (e, n) => {
  t && L.postRender(() => t(e, n));
};
class ju extends St {
  constructor() {
    super(...arguments), this.removePointerDownListener = et;
  }
  onPointerDown(e) {
    this.session = new Er(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Cr(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: i, onPanEnd: s } = this.node.getProps();
    return {
      onSessionStart: us(e),
      onStart: us(n),
      onMove: i,
      onEnd: (r, o) => {
        delete this.session, s && L.postRender(() => s(r, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = ee(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Re = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function hs(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Xt = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (P.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = hs(t, e.target.x), i = hs(t, e.target.y);
    return `${n}% ${i}%`;
  }
}, $u = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const i = t, s = xt.parse(t);
    if (s.length > 5)
      return i;
    const r = xt.createTransformer(t), o = typeof s[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    s[0 + o] /= a, s[1 + o] /= l;
    const u = k(a, l, 0.5);
    return typeof s[2 + o] == "number" && (s[2 + o] /= u), typeof s[3 + o] == "number" && (s[3 + o] /= u), r(s);
  }
};
let on = !1;
class Uu extends ia {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: i, layoutId: s } = this.props, { projection: r } = e;
    mc(Wu), r && (n.group && n.group.add(r), i && i.register && s && i.register(r), on && r.root.didUpdate(), r.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), r.setOptions({
      ...r.options,
      onExitComplete: () => this.safeToRemove()
    })), Re.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: i, drag: s, isPresent: r } = this.props, { projection: o } = i;
    return o && (o.isPresent = r, on = !0, s || e.layoutDependency !== n || n === void 0 || e.isPresent !== r ? o.willUpdate() : this.safeToRemove(), e.isPresent !== r && (r ? o.promote() : o.relegate() || L.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), si.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: i } = this.props, { projection: s } = e;
    on = !0, s && (s.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(s), i && i.deregister && i.deregister(s));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function Mr(t) {
  const [e, n] = qo(), i = U(On);
  return $(Uu, { ...t, layoutGroup: i, switchLayoutGroup: U(lr), isPresent: e, safeToRemove: n });
}
const Wu = {
  borderRadius: {
    ...Xt,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Xt,
  borderTopRightRadius: Xt,
  borderBottomLeftRadius: Xt,
  borderBottomRightRadius: Xt,
  boxShadow: $u
};
function Rr(t, e, n) {
  const i = _(t) ? t : Lt(t);
  return i.start(gi("", i, e, n)), i.animation;
}
const _u = (t, e) => t.depth - e.depth;
class Hu {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    $n(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    je(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(_u), this.isDirty = !1, this.children.forEach(e);
  }
}
function Ku(t, e) {
  const n = Z.now(), i = ({ timestamp: s }) => {
    const r = s - n;
    r >= e && (gt(i), t(r - e));
  };
  return L.setup(i, !0), () => gt(i);
}
const Lr = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Gu = Lr.length, fs = (t) => typeof t == "string" ? parseFloat(t) : t, ds = (t) => typeof t == "number" || P.test(t);
function zu(t, e, n, i, s, r) {
  s ? (t.opacity = k(0, n.opacity ?? 1, Yu(i)), t.opacityExit = k(e.opacity ?? 1, 0, Xu(i))) : r && (t.opacity = k(e.opacity ?? 1, n.opacity ?? 1, i));
  for (let o = 0; o < Gu; o++) {
    const a = `border${Lr[o]}Radius`;
    let l = ms(e, a), u = ms(n, a);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || ds(l) === ds(u) ? (t[a] = Math.max(k(fs(l), fs(u), i), 0), (ct.test(u) || ct.test(l)) && (t[a] += "%")) : t[a] = u;
  }
  (e.rotate || n.rotate) && (t.rotate = k(e.rotate || 0, n.rotate || 0, i));
}
function ms(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const Yu = /* @__PURE__ */ kr(0, 0.5, co), Xu = /* @__PURE__ */ kr(0.5, 0.95, et);
function kr(t, e, n) {
  return (i) => i < t ? 0 : i > e ? 1 : n(/* @__PURE__ */ Wt(t, e, i));
}
function ps(t, e) {
  t.min = e.min, t.max = e.max;
}
function Q(t, e) {
  ps(t.x, e.x), ps(t.y, e.y);
}
function gs(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function ys(t, e, n, i, s) {
  return t -= e, t = Be(t, 1 / n, i), s !== void 0 && (t = Be(t, 1 / s, i)), t;
}
function qu(t, e = 0, n = 1, i = 0.5, s, r = t, o = t) {
  if (ct.test(e) && (e = parseFloat(e), e = k(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let a = k(r.min, r.max, i);
  t === r && (a -= e), t.min = ys(t.min, e, n, a, s), t.max = ys(t.max, e, n, a, s);
}
function vs(t, e, [n, i, s], r, o) {
  qu(t, e[n], e[i], e[s], e.scale, r, o);
}
const Zu = ["x", "scaleX", "originX"], Ju = ["y", "scaleY", "originY"];
function Ts(t, e, n, i) {
  vs(t.x, e, Zu, n ? n.x : void 0, i ? i.x : void 0), vs(t.y, e, Ju, n ? n.y : void 0, i ? i.y : void 0);
}
function xs(t) {
  return t.translate === 0 && t.scale === 1;
}
function Ir(t) {
  return xs(t.x) && xs(t.y);
}
function bs(t, e) {
  return t.min === e.min && t.max === e.max;
}
function Qu(t, e) {
  return bs(t.x, e.x) && bs(t.y, e.y);
}
function Ss(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function Br(t, e) {
  return Ss(t.x, e.x) && Ss(t.y, e.y);
}
function ws(t) {
  return Y(t.x) / Y(t.y);
}
function Ps(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class th {
  constructor() {
    this.members = [];
  }
  add(e) {
    $n(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (je(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((s) => e === s);
    if (n === 0)
      return !1;
    let i;
    for (let s = n; s >= 0; s--) {
      const r = this.members[s];
      if (r.isPresent !== !1) {
        i = r;
        break;
      }
    }
    return i ? (this.promote(i), !0) : !1;
  }
  promote(e, n) {
    const i = this.lead;
    if (e !== i && (this.prevLead = i, this.lead = e, e.show(), i)) {
      i.instance && i.scheduleRender(), e.scheduleRender(), e.resumeFrom = i, n && (e.resumeFrom.preserveOpacity = !0), i.snapshot && (e.snapshot = i.snapshot, e.snapshot.latestValues = i.animationValues || i.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: s } = e.options;
      s === !1 && i.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: i } = e;
      n.onExitComplete && n.onExitComplete(), i && i.options.onExitComplete && i.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function eh(t, e, n) {
  let i = "";
  const s = t.x.translate / e.x, r = t.y.translate / e.y, o = (n == null ? void 0 : n.z) || 0;
  if ((s || r || o) && (i = `translate3d(${s}px, ${r}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (i += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: u, rotate: c, rotateX: h, rotateY: f, skewX: d, skewY: m } = n;
    u && (i = `perspective(${u}px) ${i}`), c && (i += `rotate(${c}deg) `), h && (i += `rotateX(${h}deg) `), f && (i += `rotateY(${f}deg) `), d && (i += `skewX(${d}deg) `), m && (i += `skewY(${m}deg) `);
  }
  const a = t.x.scale * e.x, l = t.y.scale * e.y;
  return (a !== 1 || l !== 1) && (i += `scale(${a}, ${l})`), i || "none";
}
const rn = ["", "X", "Y", "Z"], nh = 1e3;
let ih = 0;
function an(t, e, n, i) {
  const { latestValues: s } = e;
  s[t] && (n[t] = s[t], e.setStaticValue(t, 0), i && (i[t] = 0));
}
function Fr(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = br(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: s, layoutId: r } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", L, !(s || r));
  }
  const { parent: i } = t;
  i && !i.hasCheckedOptimisedAppear && Fr(i);
}
function Or({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: i, resetTransform: s }) {
  return class {
    constructor(o = {}, a = e == null ? void 0 : e()) {
      this.id = ih++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(rh), this.nodes.forEach(uh), this.nodes.forEach(hh), this.nodes.forEach(ah);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Hu());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Wn()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = ri(o) && !Xo(o), this.instance = o;
      const { layoutId: a, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), t) {
        let c, h = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        L.read(() => {
          h = window.innerWidth;
        }), t(o, () => {
          const d = window.innerWidth;
          d !== h && (h = d, this.root.updateBlockedByResize = !0, c && c(), c = Ku(f, 250), Re.hasAnimatedSinceResize && (Re.hasAnimatedSinceResize = !1, this.nodes.forEach(Cs)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: h, hasRelativeLayoutChanged: f, layout: d }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const m = this.options.transition || u.getDefaultTransition() || gh, { onLayoutAnimationStart: g, onLayoutAnimationComplete: y } = u.getProps(), p = !this.targetLayout || !Br(this.targetLayout, d), v = !h && f;
        if (this.options.layoutRoot || this.resumeFrom || v || h && (p || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const T = {
            ...ni(m, "layout"),
            onPlay: g,
            onComplete: y
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (T.delay = 0, T.type = !1), this.startAnimation(T), this.setAnimationOrigin(c, v);
        } else
          h || Cs(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = d;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), gt(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(fh), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Fr(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const h = this.path[c];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(As);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Vs);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(ch), this.nodes.forEach(sh), this.nodes.forEach(oh)) : this.nodes.forEach(Vs), this.clearAllSnapshots();
      const a = Z.now();
      H.delta = mt(0, 1e3 / 60, a - H.timestamp), H.timestamp = a, H.isProcessing = !0, Ye.update.process(H), Ye.preRender.process(H), Ye.render.process(H), H.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, si.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(lh), this.sharedNodes.forEach(dh);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, L.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      L.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Y(this.snapshot.measuredBox.x) && !Y(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = F(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && this.instance) {
        const l = i(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!s)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Ir(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      o && this.instance && (a || Ct(this.latestValues) || c) && (s(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return o && (l = this.removeTransform(l)), yh(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: o } = this.options;
      if (!o)
        return F();
      const a = o.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(vh))) {
        const { scroll: c } = this.root;
        c && (Nt(a.x, c.offset.x), Nt(a.y, c.offset.y));
      }
      return a;
    }
    removeElementScroll(o) {
      var l;
      const a = F();
      if (Q(a, o), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: h, options: f } = c;
        c !== this.root && h && f.layoutScroll && (h.wasRoot && Q(a, o), Nt(a.x, h.offset.x), Nt(a.y, h.offset.y));
      }
      return a;
    }
    applyTransform(o, a = !1) {
      const l = F();
      Q(l, o);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        !a && c.options.layoutScroll && c.scroll && c !== c.root && jt(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), Ct(c.latestValues) && jt(l, c.latestValues);
      }
      return Ct(this.latestValues) && jt(l, this.latestValues), l;
    }
    removeTransform(o) {
      const a = F();
      Q(a, o);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!u.instance || !Ct(u.latestValues))
          continue;
        Vn(u.latestValues) && u.updateSnapshot();
        const c = F(), h = u.measurePageBox();
        Q(c, h), Ts(a, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, c);
      }
      return Ct(this.latestValues) && Ts(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== H.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var f;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(o || l && this.isSharedProjectionDirty || this.isProjectionDirty || (f = this.parent) != null && f.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: h } = this.options;
      if (!(!this.layout || !(c || h))) {
        if (this.resolvedRelativeTargetAt = H.timestamp, !this.targetDelta && !this.relativeTarget) {
          const d = this.getClosestProjectingParent();
          d && d.layout && this.animationProgress !== 1 ? (this.relativeParent = d, this.forceRelativeParentToResolveTarget(), this.relativeTarget = F(), this.relativeTargetOrigin = F(), ie(this.relativeTargetOrigin, this.layout.layoutBox, d.layout.layoutBox), Q(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = F(), this.targetWithTransforms = F()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Au(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Q(this.target, this.layout.layoutBox), fr(this.target, this.targetDelta)) : Q(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const d = this.getClosestProjectingParent();
          d && !!d.resumingFrom == !!this.resumingFrom && !d.options.layoutScroll && d.target && this.animationProgress !== 1 ? (this.relativeParent = d, this.forceRelativeParentToResolveTarget(), this.relativeTarget = F(), this.relativeTargetOrigin = F(), ie(this.relativeTargetOrigin, this.target, d.target), Q(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Vn(this.parent.latestValues) || hr(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var m;
      const o = this.getLead(), a = !!this.resumingFrom || this !== o;
      let l = !0;
      if ((this.isProjectionDirty || (m = this.parent) != null && m.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === H.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      Q(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, f = this.treeScale.y;
      Wc(this.layoutCorrected, this.treeScale, this.path, a), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = F());
      const { target: d } = o;
      if (!d) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (gs(this.prevProjectionDelta.x, this.projectionDelta.x), gs(this.prevProjectionDelta.y, this.projectionDelta.y)), ne(this.projectionDelta, this.layoutCorrected, d, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== f || !Ps(this.projectionDelta.x, this.prevProjectionDelta.x) || !Ps(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = $t(), this.projectionDelta = $t(), this.projectionDeltaWithTransform = $t();
    }
    setAnimationOrigin(o, a = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, h = $t();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = F(), d = l ? l.source : void 0, m = this.layout ? this.layout.source : void 0, g = d !== m, y = this.getStack(), p = !y || y.members.length <= 1, v = !!(g && !p && this.options.crossfade === !0 && !this.path.some(ph));
      this.animationProgress = 0;
      let T;
      this.mixTargetDelta = (w) => {
        const x = w / 1e3;
        Es(h.x, o.x, x), Es(h.y, o.y, x), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (ie(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), mh(this.relativeTarget, this.relativeTargetOrigin, f, x), T && Qu(this.relativeTarget, T) && (this.isProjectionDirty = !1), T || (T = F()), Q(T, this.relativeTarget)), g && (this.animationValues = c, zu(c, u, this.latestValues, x, v, p)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = x;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var a, l, u;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (u = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || u.stop(), this.pendingAnimation && (gt(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = L.update(() => {
        Re.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Lt(0)), this.currentAnimation = Rr(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (c) => {
            this.mixTargetDelta(c), o.onUpdate && o.onUpdate(c);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(nh), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: l, layout: u, latestValues: c } = o;
      if (!(!a || !l || !u)) {
        if (this !== o && this.layout && u && Nr(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || F();
          const h = Y(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + h;
          const f = Y(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + f;
        }
        Q(a, l), jt(a, c), ne(this.projectionDeltaWithTransform, this.layoutCorrected, a, c);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new th()), this.sharedNodes.get(o).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const u = {};
      l.z && an("z", o, u, this.animationValues);
      for (let c = 0; c < rn.length; c++)
        an(`rotate${rn[c]}`, o, u, this.animationValues), an(`skew${rn[c]}`, o, u, this.animationValues);
      o.render();
      for (const c in u)
        o.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = Me(a == null ? void 0 : a.pointerEvents) || "", o.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = Me(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Ct(this.latestValues) && (o.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let h = eh(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (h = l(c, h)), o.transform = h;
      const { x: f, y: d } = this.projectionDelta;
      o.transformOrigin = `${f.origin * 100}% ${d.origin * 100}% 0`, u.animationValues ? o.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : o.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const m in ce) {
        if (c[m] === void 0)
          continue;
        const { correct: g, applyTo: y, isCSSVariable: p } = ce[m], v = h === "none" ? c[m] : g(c[m], u);
        if (y) {
          const T = y.length;
          for (let w = 0; w < T; w++)
            o[y[w]] = v;
        } else
          p ? this.options.visualElement.renderState.vars[m] = v : o[m] = v;
      }
      this.options.layoutId && (o.pointerEvents = u === this ? Me(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(As), this.root.sharedNodes.clear();
    }
  };
}
function sh(t) {
  t.updateLayout();
}
function oh(t) {
  var n;
  const e = ((n = t.resumeFrom) == null ? void 0 : n.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const { layoutBox: i, measuredBox: s } = t.layout, { animationType: r } = t.options, o = e.source !== t.layout.source;
    r === "size" ? tt((h) => {
      const f = o ? e.measuredBox[h] : e.layoutBox[h], d = Y(f);
      f.min = i[h].min, f.max = f.min + d;
    }) : Nr(r, e.layoutBox, i) && tt((h) => {
      const f = o ? e.measuredBox[h] : e.layoutBox[h], d = Y(i[h]);
      f.max = f.min + d, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[h].max = t.relativeTarget[h].min + d);
    });
    const a = $t();
    ne(a, i, e.layoutBox);
    const l = $t();
    o ? ne(l, t.applyTransform(s, !0), e.measuredBox) : ne(l, i, e.layoutBox);
    const u = !Ir(a);
    let c = !1;
    if (!t.resumeFrom) {
      const h = t.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: f, layout: d } = h;
        if (f && d) {
          const m = F();
          ie(m, e.layoutBox, f.layoutBox);
          const g = F();
          ie(g, i, d.layoutBox), Br(m, g) || (c = !0), h.options.layoutRoot && (t.relativeTarget = g, t.relativeTargetOrigin = m, t.relativeParent = h);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: i,
      snapshot: e,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: c
    });
  } else if (t.isLead()) {
    const { onExitComplete: i } = t.options;
    i && i();
  }
  t.options.transition = void 0;
}
function rh(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function ah(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function lh(t) {
  t.clearSnapshot();
}
function As(t) {
  t.clearMeasurements();
}
function Vs(t) {
  t.isLayoutDirty = !1;
}
function ch(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Cs(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function uh(t) {
  t.resolveTargetDelta();
}
function hh(t) {
  t.calcProjection();
}
function fh(t) {
  t.resetSkewAndRotation();
}
function dh(t) {
  t.removeLeadSnapshot();
}
function Es(t, e, n) {
  t.translate = k(e.translate, 0, n), t.scale = k(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Ds(t, e, n, i) {
  t.min = k(e.min, n.min, i), t.max = k(e.max, n.max, i);
}
function mh(t, e, n, i) {
  Ds(t.x, e.x, n.x, i), Ds(t.y, e.y, n.y, i);
}
function ph(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const gh = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Ms = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), Rs = Ms("applewebkit/") && !Ms("chrome/") ? Math.round : et;
function Ls(t) {
  t.min = Rs(t.min), t.max = Rs(t.max);
}
function yh(t) {
  Ls(t.x), Ls(t.y);
}
function Nr(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !Pu(ws(e), ws(n), 0.2);
}
function vh(t) {
  var e;
  return t !== t.root && ((e = t.scroll) == null ? void 0 : e.wasRoot);
}
const Th = Or({
  attachResizeListener: (t, e) => he(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), ln = {
  current: void 0
}, jr = Or({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!ln.current) {
      const t = new Th({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), ln.current = t;
    }
    return ln.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), xh = {
  pan: {
    Feature: ju
  },
  drag: {
    Feature: Nu,
    ProjectionNode: jr,
    MeasureLayout: Mr
  }
};
function ks(t, e, n) {
  const { props: i } = t;
  t.animationState && i.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const s = "onHover" + n, r = i[s];
  r && L.postRender(() => r(e, ve(e)));
}
class bh extends St {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = ql(e, (n, i) => (ks(this.node, i, "Start"), (s) => ks(this.node, s, "End"))));
  }
  unmount() {
  }
}
class Sh extends St {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = pe(he(this.node.current, "focus", () => this.onFocus()), he(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Is(t, e, n) {
  const { props: i } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && i.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const s = "onTap" + (n === "End" ? "" : n), r = i[s];
  r && L.postRender(() => r(e, ve(e)));
}
class wh extends St {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = tc(e, (n, i) => (Is(this.node, i, "Start"), (s, { success: r }) => Is(this.node, s, r ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Ln = /* @__PURE__ */ new WeakMap(), cn = /* @__PURE__ */ new WeakMap(), Ph = (t) => {
  const e = Ln.get(t.target);
  e && e(t);
}, Ah = (t) => {
  t.forEach(Ph);
};
function Vh({ root: t, ...e }) {
  const n = t || document;
  cn.has(n) || cn.set(n, {});
  const i = cn.get(n), s = JSON.stringify(e);
  return i[s] || (i[s] = new IntersectionObserver(Ah, { root: t, ...e })), i[s];
}
function Ch(t, e, n) {
  const i = Vh(e);
  return Ln.set(t, n), i.observe(t), () => {
    Ln.delete(t), i.unobserve(t);
  };
}
const Eh = {
  some: 0,
  all: 1
};
class Dh extends St {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: i, amount: s = "some", once: r } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: i,
      threshold: typeof s == "number" ? s : Eh[s]
    }, a = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, r && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: h } = this.node.getProps(), f = u ? c : h;
      f && f(l);
    };
    return Ch(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Mh(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Mh({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const Rh = {
  inView: {
    Feature: Dh
  },
  tap: {
    Feature: wh
  },
  focus: {
    Feature: Sh
  },
  hover: {
    Feature: bh
  }
}, Lh = {
  layout: {
    ProjectionNode: jr,
    MeasureLayout: Mr
  }
}, kh = {
  ...vu,
  ...Rh,
  ...xh,
  ...Lh
}, Tt = /* @__PURE__ */ jc(kh, zc);
function kn(t) {
  const e = me(() => Lt(t)), { isStatic: n } = U(Ue);
  if (n) {
    const [, i] = at(t);
    rt(() => e.on("change", i), []);
  }
  return e;
}
function $r(t, e) {
  const n = kn(e()), i = () => n.set(e());
  return i(), jn(() => {
    const s = () => L.preRender(i, !1, !0), r = t.map((o) => o.on("change", s));
    return () => {
      r.forEach((o) => o()), gt(i);
    };
  }), n;
}
function Ih(t) {
  te.current = [], t();
  const e = $r(te.current, t);
  return te.current = void 0, e;
}
function Oe(t, e, n, i) {
  if (typeof t == "function")
    return Ih(t);
  const s = typeof e == "function" ? e : De(e, n, i);
  return Array.isArray(t) ? Bs(t, s) : Bs([t], ([r]) => s(r));
}
function Bs(t, e) {
  const n = me(() => []);
  return $r(t, () => {
    n.length = 0;
    const i = t.length;
    for (let s = 0; s < i; s++)
      n[s] = t[s].get();
    return e(n);
  });
}
function Bh() {
  !pi.current && mr();
  const [t] = at(Fe.current);
  return process.env.NODE_ENV !== "production" && $e(t !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), t;
}
function vi(t) {
  return typeof t == "object" && !Array.isArray(t);
}
function Ur(t, e, n, i) {
  return typeof t == "string" && vi(e) ? _o(t, n, i) : t instanceof NodeList ? Array.from(t) : Array.isArray(t) ? t : [t];
}
function Fh(t, e, n) {
  return t * (e + 1);
}
function Fs(t, e, n, i) {
  return typeof e == "number" ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, t + parseFloat(e)) : e === "<" ? n : e.startsWith("<") ? Math.max(0, n + parseFloat(e.slice(1))) : i.get(e) ?? t;
}
function Oh(t, e, n) {
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    s.at > e && s.at < n && (je(t, s), i--);
  }
}
function Nh(t, e, n, i, s, r) {
  Oh(t, s, r);
  for (let o = 0; o < e.length; o++)
    t.push({
      value: e[o],
      at: k(s, r, i[o]),
      easing: mo(n, o)
    });
}
function jh(t, e) {
  for (let n = 0; n < t.length; n++)
    t[n] = t[n] / (e + 1);
}
function $h(t, e) {
  return t.at === e.at ? t.value === null ? 1 : e.value === null ? -1 : 0 : t.at - e.at;
}
const Uh = "easeInOut", Wh = 20;
function _h(t, { defaultTransition: e = {}, ...n } = {}, i, s) {
  const r = e.duration || 0.3, o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = {}, u = /* @__PURE__ */ new Map();
  let c = 0, h = 0, f = 0;
  for (let d = 0; d < t.length; d++) {
    const m = t[d];
    if (typeof m == "string") {
      u.set(m, h);
      continue;
    } else if (!Array.isArray(m)) {
      u.set(m.name, Fs(h, m.at, c, u));
      continue;
    }
    let [g, y, p = {}] = m;
    p.at !== void 0 && (h = Fs(h, p.at, c, u));
    let v = 0;
    const T = (w, x, S, A = 0, b = 0) => {
      const V = Hh(w), { delay: D = 0, times: R = Mo(V), type: N = "keyframes", repeat: st, repeatType: wt, repeatDelay: yt = 0, ...B } = x;
      let { ease: E = e.ease || "easeOut", duration: M } = x;
      const X = typeof D == "function" ? D(A, b) : D, G = V.length, ut = ei(N) ? N : s == null ? void 0 : s[N || "keyframes"];
      if (G <= 2 && ut) {
        let O = 100;
        if (G === 2 && zh(V)) {
          const Pt = V[1] - V[0];
          O = Math.abs(Pt);
        }
        const ht = { ...B };
        M !== void 0 && (ht.duration = /* @__PURE__ */ nt(M));
        const z = Vo(ht, O, ut);
        E = z.ease, M = z.duration;
      }
      M ?? (M = r);
      const W = h + X;
      R.length === 1 && R[0] === 0 && (R[1] = 1);
      const C = R.length - V.length;
      if (C > 0 && Do(R, C), V.length === 1 && V.unshift(null), st) {
        it(st < Wh, "Repeat count too high, must be less than 20", "repeat-count-high"), M = Fh(M, st);
        const O = [...V], ht = [...R];
        E = Array.isArray(E) ? [...E] : [E];
        const z = [...E];
        for (let Pt = 0; Pt < st; Pt++) {
          V.push(...O);
          for (let It = 0; It < O.length; It++)
            R.push(ht[It] + (Pt + 1)), E.push(It === 0 ? "linear" : mo(z, It - 1));
        }
        jh(R, st);
      }
      const q = W + M;
      Nh(S, V, E, R, W, q), v = Math.max(X + M, v), f = Math.max(q, f);
    };
    if (_(g)) {
      const w = Os(g, a);
      T(y, p, Ns("default", w));
    } else {
      const w = Ur(g, y, i, l), x = w.length;
      for (let S = 0; S < x; S++) {
        y = y, p = p;
        const A = w[S], b = Os(A, a);
        for (const V in y)
          T(y[V], Kh(p, V), Ns(V, b), S, x);
      }
    }
    c = h, h += v;
  }
  return a.forEach((d, m) => {
    for (const g in d) {
      const y = d[g];
      y.sort($h);
      const p = [], v = [], T = [];
      for (let x = 0; x < y.length; x++) {
        const { at: S, value: A, easing: b } = y[x];
        p.push(A), v.push(/* @__PURE__ */ Wt(0, f, S)), T.push(b || "easeOut");
      }
      v[0] !== 0 && (v.unshift(0), p.unshift(p[0]), T.unshift(Uh)), v[v.length - 1] !== 1 && (v.push(1), p.push(null)), o.has(m) || o.set(m, {
        keyframes: {},
        transition: {}
      });
      const w = o.get(m);
      w.keyframes[g] = p, w.transition[g] = {
        ...e,
        duration: f,
        ease: T,
        times: v,
        ...n
      };
    }
  }), o;
}
function Os(t, e) {
  return !e.has(t) && e.set(t, {}), e.get(t);
}
function Ns(t, e) {
  return e[t] || (e[t] = []), e[t];
}
function Hh(t) {
  return Array.isArray(t) ? t : [t];
}
function Kh(t, e) {
  return t && t[e] ? {
    ...t,
    ...t[e]
  } : { ...t };
}
const Gh = (t) => typeof t == "number", zh = (t) => t.every(Gh);
function Yh(t, e) {
  return t in e;
}
class Xh extends pr {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(e, n) {
    if (Yh(n, e)) {
      const i = e[n];
      if (typeof i == "string" || typeof i == "number")
        return i;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(e, n) {
    delete n.output[e];
  }
  measureInstanceViewportBox() {
    return F();
  }
  build(e, n) {
    Object.assign(e.output, n);
  }
  renderInstance(e, { output: n }) {
    Object.assign(e, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
function qh(t) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = ri(t) && !Xo(t) ? new xr(e) : new vr(e);
  n.mount(t), ue.set(t, n);
}
function Zh(t) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, n = new Xh(e);
  n.mount(t), ue.set(t, n);
}
function Jh(t, e) {
  return _(t) || typeof t == "number" || typeof t == "string" && !vi(e);
}
function Wr(t, e, n, i) {
  const s = [];
  if (Jh(t, e))
    s.push(Rr(t, vi(e) && e.default || e, n && (n.default || n)));
  else {
    const r = Ur(t, e, i), o = r.length;
    it(!!o, "No valid elements provided.", "no-valid-elements");
    for (let a = 0; a < o; a++) {
      const l = r[a];
      it(l !== null, "You're trying to perform an animation on null. Ensure that selectors are correctly finding elements and refs are correctly hydrated.", "animate-null");
      const u = l instanceof Element ? qh : Zh;
      ue.has(l) || u(l);
      const c = ue.get(l), h = { ...n };
      "delay" in h && typeof h.delay == "function" && (h.delay = h.delay(a, o)), s.push(...yi(c, { ...e, transition: h }, {}));
    }
  }
  return s;
}
function Qh(t, e, n) {
  const i = [];
  return _h(t, e, n, { spring: ae }).forEach(({ keyframes: r, transition: o }, a) => {
    i.push(...Wr(a, r, o));
  }), i;
}
function tf(t) {
  return Array.isArray(t) && t.some(Array.isArray);
}
function ef(t) {
  function e(n, i, s) {
    let r = [];
    return tf(n) ? r = Qh(n, i, t) : r = Wr(n, i, s, t), new kl(r);
  }
  return e;
}
const js = ef();
var $s = "calc(100% - env(safe-area-inset-top) - 34px)", fe = typeof window > "u", nf = {
  ease: "easeOut",
  duration: 0.2
}, sf = {
  ease: "linear",
  duration: 0.01
}, of = 0.6, rf = 500, Te = fe ? rt : Xs;
function af({
  y: t,
  rootId: e,
  sheetRef: n
}) {
  const i = K(fe ? 0 : window.innerHeight);
  function s() {
    const o = document.querySelector(`#${e}`), a = document.querySelector("body");
    o && (a.style.backgroundColor = "#000", o.style.overflow = "hidden", o.style.transitionTimingFunction = "cubic-bezier(0.32, 0.72, 0, 1)", o.style.transitionProperty = "transform, border-radius", o.style.transitionDuration = "0.5s", o.style.transformOrigin = "center top");
  }
  function r() {
    const o = document.querySelector(`#${e}`), a = document.querySelector("body");
    o && setTimeout(() => {
      a.style.removeProperty("background-color"), o.style.removeProperty("overflow"), o.style.removeProperty("transition-timing-function"), o.style.removeProperty("transition-property"), o.style.removeProperty("transition-duration"), o.style.removeProperty("transform-origin"), o.style.removeProperty("transform"), o.style.removeProperty("border-top-right-radius"), o.style.removeProperty("border-top-left-radius");
    }, 100);
  }
  Te(() => () => {
    e && r();
  }, []), rt(() => {
    const o = document.querySelector(`#${e}`);
    if (!o) return;
    function a() {
      t.get() - 10 >= i.current && r();
    }
    const l = t.on("animationStart", () => {
      var f;
      i.current = ((f = n.current) == null ? void 0 : f.offsetHeight) || window.innerHeight, s();
    }), u = t.on("change", (f) => {
      if (o) {
        const d = Math.max(0, 1 - f / i.current), m = window.innerWidth, g = (m - 16) / m, y = De(d, [0, 1], [0, 24]), p = De(d, [0, 1], [1, g]), v = De(d, [0, 1], [0, 10]), T = "env(safe-area-inset-top)";
        o.style.transform = `scale(${p}) translate3d(0, calc(${T} + ${y}px), 0)`, o.style.borderTopRightRadius = `${v}px`, o.style.borderTopLeftRadius = `${v}px`;
      }
    }), c = t.on("animationComplete", a), h = t.on("animationCancel", a);
    return () => {
      l(), u(), c(), h();
    };
  }, [t, e]);
}
function lf(t, e) {
  const n = uf(t), i = K(!1), s = de(() => {
    var r, o, a, l;
    i.current ? ((l = (a = e.current).onCloseEnd) == null || l.call(a), i.current = !1) : ((o = (r = e.current).onOpenEnd) == null || o.call(r), i.current = !0);
  }, [t, n]);
  return rt(() => {
    var r, o, a, l;
    !n && t ? (o = (r = e.current).onOpenStart) == null || o.call(r) : !t && n && ((l = (a = e.current).onCloseStart) == null || l.call(a));
  }, [t, n]), { handleAnimationComplete: s };
}
function cf() {
  const [t, e] = at({
    height: fe ? 0 : window.innerHeight,
    width: fe ? 0 : window.innerWidth
  });
  return Te(() => {
    function n() {
      e({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), t;
}
function uf(t) {
  const e = K(void 0);
  return rt(() => {
    e.current = t;
  }), e.current;
}
function un(t) {
  const e = K(void 0);
  return Te(() => {
    e.current = t;
  }), de((...n) => {
    const i = e.current;
    return i == null ? void 0 : i(...n);
  }, []);
}
var hf = { bottom: 0, top: 0, left: 0, right: 0 };
function _r() {
  const t = K(null), e = de(() => hf, []);
  return { constraintsRef: t, onMeasureDragConstraints: e };
}
var Hr = bt(
  void 0
), Ke = () => {
  const t = U(Hr);
  if (!t) throw new Error("Sheet context error");
  return t;
}, Kr = bt(void 0);
function ff({
  children: t
}) {
  const e = Ke(), [n, i] = at(!!e.disableDrag);
  function s() {
    e.disableDrag || i(!1);
  }
  function r() {
    n || i(!0);
  }
  return /* @__PURE__ */ J.createElement(
    Kr.Provider,
    {
      value: { disableDrag: n, setDragEnabled: s, setDragDisabled: r }
    },
    t
  );
}
var Gr = () => {
  const t = U(Kr);
  if (!t) throw new Error("Sheet scroller context error");
  return t;
};
function Us(t, e) {
  let n = t[0], i = Math.abs(t[0] - e);
  for (let s = 1; s < t.length; s++) {
    const r = Math.abs(t[s] - e);
    r < i && (n = t[s], i = r);
  }
  return n;
}
function df(t) {
  for (let e = 0; e < t.length; e++)
    if (t[e + 1] > t[e]) return !1;
  return !0;
}
function Ws({
  snapTo: t,
  sheetHeight: e
}) {
  return t < 0 && console.warn(
    `Snap point is out of bounds. Sheet height is ${e} but snap point is ${e + Math.abs(t)}.`
  ), Math.max(Math.round(t), 0);
}
function Ti(t) {
  return (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n && (n.current = e);
    });
  };
}
function mf() {
  return typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function xi(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(
    // @ts-expect-error
    ((e = window.navigator.userAgentData) == null ? void 0 : e.platform) || window.navigator.platform
  ) : !1;
}
function Ge(t) {
  let e = null;
  return () => (e == null && (e = t()), e);
}
var pf = Ge(function() {
  return xi(/^Mac/i);
}), gf = Ge(function() {
  return xi(/^iPhone/i);
}), yf = Ge(function() {
  return xi(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  pf() && navigator.maxTouchPoints > 1;
}), vf = Ge(function() {
  return gf() || yf();
}), Tf = 24;
function In(...t) {
  return (...e) => {
    for (const n of t)
      typeof n == "function" && n(...e);
  };
}
var hn = typeof document < "u" && window.visualViewport;
function _s(t, e) {
  if (!t)
    return !1;
  const n = window.getComputedStyle(t);
  let i = /(auto|scroll)/.test(
    n.overflow + n.overflowX + n.overflowY
  );
  return i && e && (i = t.scrollHeight !== t.clientHeight || t.scrollWidth !== t.clientWidth), i;
}
function zr(t, e) {
  let n = t;
  for (_s(n, e) && (n = n.parentElement); n && !_s(n, e); )
    n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
var xf = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), Ae = 0, Ve;
function bf(t = {}) {
  const { isDisabled: e } = t;
  Te(() => {
    if (!e)
      return Ae++, Ae === 1 && (vf() ? Ve = wf() : Ve = Sf()), () => {
        Ae--, Ae === 0 && (Ve == null || Ve());
      };
  }, [e]);
}
function Sf() {
  return In(
    se(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    se(document.documentElement, "overflow", "hidden")
  );
}
function wf() {
  let t, e = 0;
  const n = (h) => {
    var f;
    const d = (f = h.composedPath()) == null ? void 0 : f[0];
    t = zr(d, !0), !(t === document.documentElement && t === document.body) && (e = h.changedTouches[0].pageY);
  }, i = (h) => {
    if (t === void 0)
      return;
    if (!t || t === document.documentElement || t === document.body) {
      h.preventDefault();
      return;
    }
    const f = h.changedTouches[0].pageY, d = t.scrollTop, m = t.scrollHeight - t.clientHeight;
    m !== 0 && ((d <= 0 && f > e || d >= m && f < e) && h.preventDefault(), e = f);
  }, s = (h) => {
    var f;
    const d = (f = h.composedPath()) == null ? void 0 : f[0];
    Ks(d) && d !== document.activeElement && (h.preventDefault(), d.style.transform = "translateY(-2000px)", d.focus(), requestAnimationFrame(() => {
      d.style.transform = "";
    }));
  }, r = (h) => {
    var f;
    const d = (f = h.composedPath()) == null ? void 0 : f[0];
    Ks(d) && (d.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      d.style.transform = "", hn && (hn.height < window.innerHeight ? requestAnimationFrame(() => {
        Hs(d);
      }) : hn.addEventListener(
        "resize",
        () => Hs(d),
        { once: !0 }
      ));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, u = In(
    se(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    se(document.documentElement, "overflow", "hidden"),
    se(document.body, "marginTop", `-${l}px`)
  );
  window.scrollTo(0, 0);
  const c = In(
    qt(document, "touchstart", n, {
      passive: !1,
      capture: !0
    }),
    qt(document, "touchmove", i, {
      passive: !1,
      capture: !0
    }),
    qt(document, "touchend", s, {
      passive: !1,
      capture: !0
    }),
    qt(document, "focus", r, !0),
    qt(window, "scroll", o)
  );
  return () => {
    u(), c(), window.scrollTo(a, l);
  };
}
function se(t, e, n) {
  const i = t.style[e];
  return t.style[e] = n, () => {
    t.style[e] = i;
  };
}
function qt(t, e, n, i) {
  return t.addEventListener(e, n, i), () => {
    t.removeEventListener(e, n, i);
  };
}
function Hs(t) {
  const e = document.scrollingElement || document.documentElement;
  for (; t && t !== e; ) {
    const n = zr(t);
    if (n !== document.documentElement && n !== document.body && n !== t) {
      const i = n.getBoundingClientRect().top, s = t.getBoundingClientRect().top, r = t.getBoundingClientRect().bottom, o = n.getBoundingClientRect().bottom + Tf;
      r > o && (n.scrollTop += s - i);
    }
    t = n.parentElement;
  }
}
function Ks(t) {
  return t instanceof HTMLInputElement && !xf.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
var ft = {
  wrapper: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden",
    pointerEvents: "none"
  },
  backdrop: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    touchAction: "none",
    // Disable iOS body scrolling
    border: "none",
    WebkitTapHighlightColor: "transparent"
  },
  container: {
    zIndex: 2,
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  },
  headerWrapper: {
    width: "100%"
  },
  header: {
    height: "40px",
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  indicator: {
    width: "18px",
    height: "4px",
    borderRadius: "99px",
    backgroundColor: "#ddd"
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "0px",
    position: "relative"
  },
  scroller: {
    height: "100%",
    overflowY: "auto"
  }
}, Yr = kt(
  ({
    onOpenStart: t,
    onOpenEnd: e,
    onClose: n,
    onCloseStart: i,
    onCloseEnd: s,
    onSnap: r,
    children: o,
    disableScrollLocking: a = !1,
    isOpen: l,
    snapPoints: u,
    rootId: c,
    mountPoint: h,
    style: f,
    detent: d = "full-height",
    initialSnap: m = 0,
    disableDrag: g = !1,
    prefersReducedMotion: y = !1,
    tweenConfig: p = nf,
    dragVelocityThreshold: v = rf,
    dragCloseThreshold: T = of,
    ...w
  }, x) => {
    const S = K(null), A = kn(0), { height: b } = cf(), V = Bh(), D = !!(y || V), R = {
      type: "tween",
      ...D ? sf : p
    }, N = kn(b), st = Oe(
      N,
      (C) => C + 2 >= b ? -1 : (f == null ? void 0 : f.zIndex) ?? 9999
    ), wt = Oe(
      N,
      (C) => C + 2 >= b ? "hidden" : "visible"
    ), yt = K({
      onOpenStart: t,
      onOpenEnd: e,
      onCloseStart: i,
      onCloseEnd: s
    });
    Te(() => {
      yt.current = {
        onOpenStart: t,
        onOpenEnd: e,
        onCloseStart: i,
        onCloseEnd: s
      };
    });
    let B = u;
    B && (B = B.map((C) => C > 0 && C <= 1 ? Math.round(C * b) : C < 0 ? b + C : C), console.assert(
      df(B) || b === 0,
      `Snap points need to be in descending order got: [${B.join(
        ", "
      )}]`
    ));
    const E = un((C, { delta: q }) => {
      const O = N.getVelocity();
      O > 0 && A.set(10), O < 0 && A.set(-10), N.set(Math.max(N.get() + q.y, 0));
    }), M = un(() => {
      const C = document.activeElement;
      if (!C || !S.current) return;
      (C.tagName === "INPUT" || C.tagName === "TEXTAREA") && S.current.contains(C) && C.blur();
    }), X = un((C, { velocity: q }) => {
      if (q.y > v)
        n();
      else {
        const O = S.current.getBoundingClientRect().height, ht = N.get();
        let z = 0;
        if (B) {
          const Yt = B.map(
            (ze) => O - Math.min(ze, O)
          );
          d === "content-height" && !Yt.includes(0) && Yt.unshift(0), z = Us(Yt, ht);
        } else ht / O > T && (z = O);
        if (z = Ws({ snapTo: z, sheetHeight: O }), js(N, z, R), B && r) {
          const Yt = Math.abs(Math.round(B[0] - z)), ze = B.indexOf(
            Us(B, Yt)
          );
          r(ze);
        }
        const Pt = Math.round(O);
        z + 2 >= Pt && n();
      }
      A.set(0);
    });
    rt(() => {
      if (!B || !r) return;
      const C = l ? m : B.length - 1;
      r(C);
    }, [l]), sa(x, () => ({
      y: N,
      snapTo: (C) => {
        const q = S.current;
        if ((B == null ? void 0 : B[C]) !== void 0 && q) {
          const O = q.getBoundingClientRect().height, ht = B[C], z = Ws({
            snapTo: O - ht,
            sheetHeight: O
          });
          js(N, z, R), r && r(C), z >= O && n();
        }
      }
    })), af({
      y: N,
      rootId: c,
      sheetRef: S
    }), bf({ isDisabled: a || !l });
    const G = dt(() => g ? void 0 : {
      drag: "y",
      dragElastic: 0,
      dragMomentum: !1,
      dragPropagation: !1,
      onDrag: E,
      onDragStart: M,
      onDragEnd: X
    }, [g, b]), ut = {
      y: N,
      sheetRef: S,
      isOpen: l,
      initialSnap: m,
      snapPoints: B,
      detent: d,
      indicatorRotation: A,
      callbacks: yt,
      dragProps: G,
      windowHeight: b,
      animationOptions: R,
      reduceMotion: D,
      disableDrag: g
    }, W = /* @__PURE__ */ J.createElement(Hr.Provider, { value: ut }, /* @__PURE__ */ J.createElement(
      Tt.div,
      {
        ...w,
        ref: x,
        style: { ...ft.wrapper, zIndex: st, visibility: wt, ...f }
      },
      /* @__PURE__ */ J.createElement(ac, null, l ? /* @__PURE__ */ J.createElement(ff, null, Zs.map(
        o,
        (C, q) => oa(C, { key: `sheet-child-${q}` })
      )) : null)
    ));
    return fe ? W : aa(W, h ?? document.body);
  }
);
Yr.displayName = "Sheet";
var Xr = kt(
  ({ children: t, style: e = {}, className: n = "", ...i }, s) => {
    const {
      y: r,
      isOpen: o,
      callbacks: a,
      snapPoints: l,
      initialSnap: u = 0,
      sheetRef: c,
      windowHeight: h,
      detent: f,
      animationOptions: d,
      reduceMotion: m
    } = Ke(), { handleAnimationComplete: g } = lf(o, a), y = l ? l[0] - l[u] : 0, p = l ? l[0] : null, v = p !== null ? `min(${p}px, ${$s})` : $s;
    return /* @__PURE__ */ J.createElement(
      Tt.div,
      {
        ...i,
        ref: Ti([c, s]),
        className: `react-modal-sheet-container ${n}`,
        style: {
          ...ft.container,
          ...e,
          ...f === "full-height" && { height: v },
          ...f === "content-height" && { maxHeight: v },
          y: r
        },
        initial: m ? !1 : { y: h },
        animate: { y, transition: d },
        exit: { y: h, transition: d },
        onAnimationComplete: g
      },
      t
    );
  }
);
Xr.displayName = "SheetContainer";
var qr = kt(
  ({ children: t, style: e, disableDrag: n, className: i = "", ...s }, r) => {
    const o = Ke(), a = Gr(), { constraintsRef: l, onMeasureDragConstraints: u } = _r(), c = n || a.disableDrag ? void 0 : o.dragProps;
    return /* @__PURE__ */ J.createElement(
      Tt.div,
      {
        ...s,
        ref: Ti([r, l]),
        className: `react-modal-sheet-content ${i}`,
        style: { ...ft.content, ...e },
        ...c,
        dragConstraints: l,
        onMeasureDragConstraints: u
      },
      t
    );
  }
);
qr.displayName = "SheetContent";
var Zr = kt(
  ({ children: t, style: e, disableDrag: n, ...i }, s) => {
    const { indicatorRotation: r, dragProps: o } = Ke(), { constraintsRef: a, onMeasureDragConstraints: l } = _r(), u = n ? void 0 : o, c = Oe(
      r,
      (f) => `translateX(2px) rotate(${f}deg)`
    ), h = Oe(
      r,
      (f) => `translateX(-2px) rotate(${-1 * f}deg)`
    );
    return /* @__PURE__ */ J.createElement(
      Tt.div,
      {
        ...i,
        ref: Ti([s, a]),
        style: { ...ft.headerWrapper, ...e },
        ...u,
        dragConstraints: a,
        onMeasureDragConstraints: l
      },
      t || /* @__PURE__ */ J.createElement("div", { className: "react-modal-sheet-header", style: ft.header }, /* @__PURE__ */ J.createElement(
        Tt.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...ft.indicator, transform: c }
        }
      ), /* @__PURE__ */ J.createElement(
        Tt.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...ft.indicator, transform: h }
        }
      ))
    );
  }
);
Zr.displayName = "SheetHeader";
var Gs = (t) => !!t.onClick || !!t.onTap, Jr = kt(
  ({ style: t = {}, className: e = "", ...n }, i) => {
    const s = Gs(n) ? Tt.button : Tt.div, r = Gs(n) ? "auto" : "none";
    return /* @__PURE__ */ J.createElement(
      s,
      {
        ...n,
        ref: i,
        className: `react-modal-sheet-backdrop ${e}`,
        style: { ...ft.backdrop, ...t, pointerEvents: r },
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }
    );
  }
);
Jr.displayName = "SheetBackdrop";
var Qr = kt(
  ({ draggableAt: t = "top", children: e, style: n, className: i = "", ...s }, r) => {
    const o = Gr();
    function a(h) {
      const { scrollTop: f, scrollHeight: d, clientHeight: m } = h;
      if (!(d > m)) return;
      const y = f <= 0, p = d - f === m;
      t === "top" && y || t === "bottom" && p || t === "both" && (y || p) ? o.setDragEnabled() : o.setDragDisabled();
    }
    function l(h) {
      a(h.currentTarget), s.onScroll && s.onScroll(h);
    }
    function u(h) {
      a(h.currentTarget), s.onTouchStart && s.onTouchStart(h);
    }
    const c = mf() ? { onScroll: l, onTouchStart: u } : void 0;
    return /* @__PURE__ */ J.createElement(
      "div",
      {
        ...s,
        ref: r,
        className: `react-modal-sheet-scroller ${i}`,
        style: { ...ft.scroller, ...n },
        ...c
      },
      e
    );
  }
);
Qr.displayName = "SheetScroller";
var Vt = Object.assign(Yr, {
  Container: Xr,
  Header: Zr,
  Content: qr,
  Backdrop: Jr,
  Scroller: Qr
});
const ta = () => /* @__PURE__ */ $("div", { className: "flex items-center justify-center pb-12", children: /* @__PURE__ */ $("div", { className: "h-4 w-48 rounded-full bg-interaction-neutral-disable-main" }) });
ta.displayName = "BottomSheetIndicator";
const zs = 0.94, Pf = 0.5, Af = (t) => {
  var ut;
  const {
    isOpen: e,
    header: n,
    headerType: i = "default",
    footer: s,
    footerType: r = "default",
    noDragIndicator: o,
    os: a,
    height: l,
    contentDisableDrag: u,
    dialogOptions: c = {},
    onClose: h,
    children: f,
    onSnap: d,
    onCloseEnd: m,
    onOpenEnd: g,
    onBackdropClick: y,
    zIndex: p,
    mode: v = "overflow",
    hasBottomGradation: T = !0,
    bottomSheetBodyRef: w,
    onAnimationEnd: x,
    onScroll: S,
    ...A
  } = t, b = a === "etc", V = K(null), D = K(null), [R, N] = at(!1), [st, wt] = at(!1), [yt, B] = at(0), [E, M] = at(!1);
  la({ show: e, mode: v });
  const X = dt(() => {
    switch (l) {
      case "contents":
        return { detent: "content-height" };
      case "half":
        return {
          detent: "content-height",
          initialSnap: 1,
          snapPoints: [zs, Pf, 0]
        };
      case "full":
        return {
          detent: "full-height"
        };
      default:
        return l ? { initialSnap: 1, snapPoints: [zs, l, 0] } : {};
    }
  }, [l]), G = ua(() => {
    if (D.current) {
      const { scrollTop: W, scrollHeight: C, clientHeight: q } = D.current, O = W + q >= C;
      wt(!O);
    }
  }, 100);
  return rt(() => {
    if (E && D.current) {
      const { scrollHeight: W, clientHeight: C } = D.current;
      N(typeof l == "number" ? W > l : W > C);
    }
  }, [E, l]), rt(() => {
    var W;
    if (!(!e && !E))
      return G(), (W = D.current) == null || W.addEventListener("scroll", G), () => {
        var C;
        (C = D.current) == null || C.removeEventListener("scroll", G);
      };
  }, [E, e]), /* @__PURE__ */ $(Ys, { children: b ? (
    /**
     * pc일 경우 pc-dialog-sheet 호출
     * TODO: 추후 사용성을 보고 독립적으로 사용할지 고려 필요
     */
    /* @__PURE__ */ $(
      ca,
      {
        body: f,
        bodyType: c.bodyType,
        bottomSheetBodyRef: w,
        className: c.className,
        footer: s,
        footerType: c.footerType,
        hasBottomGradation: T,
        height: c.height,
        id: c.id,
        noCloseIcon: c.noCloseIcon,
        onAnimationEnd: x,
        onBackdropClick: c.onBackdropClick,
        onClose: h,
        onScroll: S,
        show: e,
        title: n,
        titleType: c.titleType,
        zIndex: p
      }
    )
  ) : /* @__PURE__ */ Zt(
    Vt,
    {
      ...X,
      dragCloseThreshold: 0.4,
      dragVelocityThreshold: 100,
      isOpen: e,
      onClose: h,
      ...A,
      disableScrollLocking: !0,
      onCloseEnd: () => {
        M(!1), m == null || m();
      },
      onOpenEnd: () => {
        M(!0), g == null || g();
      },
      onScroll: S,
      onSnap: (W) => {
        B(W), d == null || d(W), G();
      },
      ref: V,
      rootId: "root",
      style: {
        zIndex: p
      },
      children: [
        /* @__PURE__ */ $("div", { className: "absolute inset-y-0 left-1/2 z-[2] w-full max-w-mobile-size -translate-x-1/2 overflow-hidden", children: /* @__PURE__ */ Zt(
          Vt.Container,
          {
            className: "!rounded-t-28 will-change-transform shadow-3",
            style: { paddingBottom: "env(safe-area-inset-bottom)" },
            children: [
              /* @__PURE__ */ Zt(Vt.Header, { className: xe("py-12", { "px-24": i === "default" }), children: [
                !o && /* @__PURE__ */ $(ta, {}),
                !!n && (i === "default" ? /* @__PURE__ */ $("div", { className: "flex items-center justify-center pb-4 pt-16 typography-subtitle-20-bold", children: n }) : n)
              ] }),
              /* @__PURE__ */ Zt(Vt.Content, { disableDrag: u, children: [
                /* @__PURE__ */ $(
                  Vt.Scroller,
                  {
                    className: xe({ "!overflow-hidden": R && yt !== 0 }),
                    ref: ra([D, w]),
                    children: f
                  }
                ),
                R && T ? /* @__PURE__ */ $(
                  "div",
                  {
                    className: xe(
                      "pointer-events-none absolute inset-x-0 bottom-0 z-50 h-80 opacity-0 transition-opacity duration-500",
                      {
                        "opacity-100": st
                      }
                    ),
                    style: {
                      background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 82.36%)"
                    }
                  }
                ) : null
              ] }),
              /* @__PURE__ */ $(
                Vt.Content,
                {
                  className: "!shrink-0 !grow-0",
                  style: { paddingBottom: l !== "contents" ? (ut = V.current) == null ? void 0 : ut.y : 0 },
                  children: !!s && /* @__PURE__ */ $("div", { className: xe("", { "px-20 py-12": r === "default" }), children: s })
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ $(
          Vt.Backdrop,
          {
            className: "!bg-scrim",
            onTap: (W) => {
              setTimeout(() => {
                y == null || y(W), h();
              }, 50);
            }
          }
        )
      ]
    }
  ) });
};
Af.displayName = "NDS.BottomSheet";
export {
  Af as B
};
